function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3000 2000",
    style: {
      enableBackground: "new 0 0 3000 2000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1B4870"
    },
    width: 3000,
    height: 2000
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22,
      fill: "#15325C"
    },
    d: "M2169.138,741.746c-0.364,0.26-0.741,0.494-1.144,0.728l-148.179,85.558 l-26.565,15.33l-141.054,81.436c-3.368,1.938-7.282,2.497-10.948,1.651c-1.469-0.325-2.913-0.884-4.252-1.664l-141.99-82.424 l-1.378-0.806c-0.377-0.221-0.741-0.455-1.092-0.702c-4.317-2.991-6.462-7.698-6.462-12.405c0-5.149,2.548-10.285,7.659-13.198 l1.339-0.767l61.321-34.99c0.416-0.234,0.819-0.494,1.209-0.78c8.881-6.176,8.608-19.738-0.963-25.433l-81.67-48.682 l-3.121-1.859c-0.325-0.195-0.65-0.403-0.949-0.611c-3.966-2.756-6.098-6.943-6.41-11.26c-0.065-0.793-0.065-1.586,0-2.38 c0.013-0.195,0.026-0.39,0.052-0.572c0.533-4.525,3.055-8.829,7.568-11.404l207.641-118.234 c4.681-2.666,10.428-2.64,15.096,0.052l273.162,157.866C2177.707,721.8,2178.097,735.505,2169.138,741.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M2175.363,643.784l0.274-20.472l-280.792-145.469c-4.668-2.704-10.415-2.717-15.096-0.052 l-204.842,116.647l-10.419-11.907l-0.049,25.334l0.064-0.052l-0.001,0.006c-0.494,5.487,1.938,11.208,7.346,14.433l84.791,50.529 c0.338,0.195,0.65,0.403,0.963,0.611c8.998,6.307,8.556,20.051-1.209,25.616l-38.449,21.935l-17.294,9.869l0.585-0.637 l-15.161-7.048l0.039,23.704c-0.39,5.448,2.107,11.091,7.516,14.238l135.515,78.654l7.854,4.564 c1.469,0.858,3.056,1.443,4.681,1.768c3.537,0.702,7.294,0.117,10.519-1.742l141.053-81.436l26.565-15.343l144.57-81.618 c3.444-1.962,6.286-4.688,8.367-7.893C2175.449,653.87,2175.568,648.916,2175.363,643.784z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1993.251,738.044 1993.251,762.874 2019.816,747.537 2019.816,722.706  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2025.296,719.542 2025.296,744.373 2035.171,738.672 2035.171,713.841  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M1841.677,821.518v24.536l-12.535-6.332l-135.515-78.654c-5.409-3.147-7.906-8.79-7.516-14.238 l-0.039-23.704c0-5.149,2.548-10.285,7.659-13.198l1.339-0.767c7.229,3.823,15.59,8.179,22.872,11.781 c8.153,4.044,14.953,7.164,17.28,7.593c6.996,1.248,98.964,86.078,106.024,92.593 C1841.534,821.388,1841.677,821.518,1841.677,821.518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2169.138,636.424c-0.364,0.26-0.741,0.494-1.144,0.728l-148.179,85.558l-26.565,15.33 l-141.054,81.436c-3.368,1.938-7.282,2.497-10.948,1.651c-1.469-0.325-2.913-0.884-4.252-1.664l-141.99-82.424l-1.378-0.806 c-0.377-0.221-0.741-0.455-1.092-0.702c-4.317-2.991-6.462-7.698-6.462-12.405c0-5.149,2.548-10.285,7.659-13.198l1.339-0.767 l61.321-34.99c0.416-0.234,0.819-0.494,1.209-0.78c8.881-6.176,8.608-19.738-0.963-25.433l-81.67-48.682l-3.121-1.859 c-0.325-0.195-0.65-0.403-0.949-0.611c-3.966-2.757-6.098-6.943-6.41-11.26c-0.065-0.793-0.065-1.586,0-2.38 c0.013-0.195,0.026-0.39,0.052-0.572c0.533-4.525,3.055-8.829,7.568-11.404l207.641-118.234 c4.681-2.666,10.428-2.64,15.096,0.052l273.162,157.866C2177.707,616.478,2178.097,630.183,2169.138,636.424z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M1716.061,659.305v20.756l-0.11-0.08c-0.309,1.833-1.374,3.556-3.207,4.612l-69.747,40.267 c-1.036,0.598-2.191,0.896-3.347,0.886c-1.135-0.01-2.271-0.299-3.286-0.886l-69.827-40.426 c-2.211-1.275-3.297-3.516-3.297-5.747v-19.382l14.641,7.121l58.373-33.614c2.052-1.175,4.571-1.175,6.623,0.01l45.097,26.005 l11.703,6.743L1716.061,659.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M1716.061,659.305v20.756l-0.11-0.08c-0.309,1.833-1.374,3.556-3.207,4.612l-69.747,40.267 c-1.036,0.598-2.191,0.896-3.347,0.886v-24.989l48.324-41.93l11.703,6.743L1716.061,659.305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1636.251,613.282l-69.697,40.127c-4.425,2.548-4.433,8.931-0.014,11.49l69.82,40.423 c2.053,1.189,4.586,1.19,6.641,0.004l69.746-40.268c4.424-2.554,4.422-8.94-0.004-11.492l-69.869-40.283 C1640.825,612.103,1638.301,612.102,1636.251,613.282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1636.251,612.658l-69.697,40.127c-4.425,2.548-4.433,8.931-0.014,11.49l69.82,40.423 c2.053,1.189,4.586,1.19,6.641,0.004l69.746-40.268c4.424-2.554,4.422-8.94-0.004-11.492l-69.869-40.283 C1640.825,611.479,1638.301,611.478,1636.251,612.658z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1585.042,654.962 1638.554,623.628 1693.583,654.962 1639.312,686.295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "1585.042,604.305 1638.554,572.972 1693.583,604.305 1639.312,635.638  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1585.042,636.449 1585.042,604.305 1639.312,635.638 1638.744,667.299  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1693.583,604.305 1639.312,635.638 1638.744,667.299 1693.014,636.449  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1584.473,548.187 1637.985,516.854 1693.014,548.187 1638.744,579.52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1584.473,580.331 1584.473,548.187 1638.744,579.52 1638.175,611.181  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1693.014,548.187 1638.744,579.52 1638.175,611.181 1692.445,580.331  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183561"
    },
    d: "M1899.918,564.958v-6.455l-4.565,2.85l-45.936-26.48c-1.067-0.615-2.38-0.618-3.45-0.008 l-58.505,33.352l-4.572-2.694v7.134l0.148-0.112c0.134,0.514,0.461,0.986,0.984,1.289l49.394,28.606 c1.074,0.622,2.398,0.623,3.473,0.002l62.139-35.876C1899.644,566.213,1899.939,565.581,1899.918,564.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EFFB"
    },
    d: "M1845.926,527.873l-61.932,35.306c-1.417,0.808-1.424,2.847-0.012,3.665l49.394,28.606 c1.074,0.622,2.398,0.623,3.473,0.002l62.139-35.876c1.192-0.688,1.192-2.409-0.001-3.097l-49.61-28.598 C1848.309,527.266,1846.996,527.263,1845.926,527.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183561"
    },
    d: "M1862.918,515.889l-4.865,36.445l-33.079,26.966l-4.943-2.785 c-0.645-0.307-1.174-0.785-1.539-1.364c-0.366-0.579-0.572-1.263-0.572-1.976l0.069-33.567c0-0.808,0.216-1.583,0.61-2.256 c0.386-0.661,0.94-1.222,1.621-1.618l36.083-20.996c1.179-0.686,2.611-0.749,3.843-0.173L1862.918,515.889z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1866.992,514.357 1866.879,554.973 1824.756,579.301 1824.793,538.91  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D1EA"
    },
    d: "M1936.795,263.17l9.767,5.259l-14.607,195.511l-202.253,131.464l-8.024-4.321 c-2.027-1.092-3.673-2.696-4.812-4.603c-1.139-1.907-1.771-4.117-1.771-6.419V393.09c0-1.721,0.456-3.377,1.284-4.82 c0.828-1.443,2.026-2.674,3.511-3.543l207.321-121.385c1.277-0.748,2.684-1.184,4.112-1.306 C1933.188,261.876,1935.092,262.253,1936.795,263.17z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "1946.562,268.429 1946.562,471.805 1729.702,595.404 1729.702,395.399  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1942.067,293.081 1942.067,456.12 1916.4,470.746 1908.691,475.144 1855.993,505.179  1826.801,521.813 1780.967,547.94 1736.443,573.317 1736.443,413.473 1780.025,387.959 1803.616,374.144 1840.838,352.354  1885.621,326.127 1913.511,309.799 1933.869,297.885  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2042.979,611.037l50.012-29.284c1.393-0.816,3.115-0.826,4.518-0.027 l51.525,29.338c3.032,1.727,3.046,6.093,0.023,7.838l-50.721,29.284c-1.398,0.807-3.12,0.807-4.518,0l-50.816-29.339 C2040.002,617.115,2039.989,612.788,2042.979,611.037z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2136.225,592.025 2096.494,614.963 2096.078,638.142 2135.808,615.557  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "2056.764,592.025 2095.939,569.086 2136.225,592.025 2096.494,614.963  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15325C"
    },
    points: "2073.963,592.025 2095.769,579.257 2118.192,592.025 2096.078,604.792  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2056.764,615.557 2056.764,592.025 2096.494,614.963 2096.078,638.142  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2115.03,582.015c-1.952,2.995-4.679,5.909-8.502,8.341c-8.849,7.112-24.782,5.374-29.248-3.181 c0,0-7.405-6.176-6.229-16.816c1.924,5.267,6.469,8.448,7.031,8.823c-7.298-6.229-2.647-24.462-2.647-24.462 s1.791,8.261,9.17,14.437c0,0-2.273-12.218,0.615-23.874c1.417-5.802,4.144-11.496,9.037-15.426 c-2.032,18.607,7.458,30.397,7.458,30.397c6.176-7.406,4.678-18.313,4.678-18.313s8.903,17.083,4.813,30.103 c5.588-2.085,8.823-7.111,8.823-7.111S2120.536,573.728,2115.03,582.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2115.03,582.015c-1.952,2.995-4.679,5.909-8.502,8.341 c-2.139,1.711-4.705,2.914-7.432,3.636c-8.475,2.246-18.42-0.347-21.815-6.817c0,0-7.405-6.176-6.229-16.816 c1.924,5.267,6.469,8.448,7.031,8.823c-7.298-6.229-2.647-24.462-2.647-24.462s0.749,3.422,3.235,7.486 c1.364,2.273,3.288,4.759,5.935,6.951c0,0-2.273-12.218,0.615-23.874C2085.193,571.428,2098.614,582.39,2115.03,582.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2099.095,593.992c-8.475,2.246-18.42-0.347-21.815-6.817 c0,0-7.405-6.176-6.229-16.816c1.924,5.267,6.469,8.448,7.031,8.823c-7.298-6.229-2.647-24.462-2.647-24.462 s0.749,3.422,3.235,7.486C2081.156,580.919,2091.664,589.902,2099.095,593.992z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2089.636,573.934c1.013,1.554,2.427,3.066,4.411,4.328c4.591,3.69,12.859,2.788,15.175-1.651 c0,0,3.843-3.204,3.232-8.725c-0.998,2.733-3.357,4.383-3.648,4.578c3.787-3.232,1.373-12.693,1.373-12.693 s-0.929,4.286-4.758,7.491c0,0,1.179-6.339-0.319-12.387c-0.735-3.01-2.15-5.965-4.688-8.004 c1.054,9.654-3.87,15.772-3.87,15.772c-3.204-3.842-2.427-9.502-2.427-9.502s-4.619,8.864-2.497,15.619 c-2.899-1.082-4.578-3.69-4.578-3.69S2086.779,569.634,2089.636,573.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2089.636,573.934c1.013,1.554,2.427,3.066,4.411,4.328 c1.11,0.888,2.441,1.512,3.856,1.886c4.397,1.165,9.557-0.18,11.319-3.537c0,0,3.843-3.204,3.232-8.725 c-0.998,2.733-3.357,4.383-3.648,4.578c3.787-3.232,1.373-12.693,1.373-12.693s-0.388,1.776-1.678,3.884 c-0.708,1.179-1.706,2.469-3.079,3.607c0,0,1.179-6.339-0.319-12.387C2105.117,568.441,2098.153,574.128,2089.636,573.934z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2097.904,580.148c4.397,1.165,9.557-0.18,11.319-3.537 c0,0,3.843-3.204,3.232-8.725c-0.998,2.733-3.357,4.383-3.648,4.578c3.787-3.232,1.373-12.693,1.373-12.693 s-0.388,1.776-1.678,3.884C2107.211,573.365,2101.76,578.026,2097.904,580.148z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2143.919,433.528 2143.919,497.96 2142.099,499.416 2087.131,465.562 2085.311,402.585  2087.131,401.129  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2085.311,402.585 2085.311,467.018 2142.099,499.416 2142.099,434.984  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "2085.311,402.585 2085.311,416.054 2142.099,448.453 2142.099,434.984  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2089.249,428.067 2089.275,432.548 2120.13,450.424 2119.941,445.819  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2104.689,465.411 2104.716,469.891 2135.571,487.767 2135.382,483.162  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2123.677,448.038 2123.677,452.381 2135.274,459.105 2135.274,454.764  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2094.237,450.297 2094.237,454.64 2105.834,461.365 2105.834,457.024  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2090.482,458.06 2090.482,462.403 2102.08,469.128 2102.08,464.786  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2108.317,448.038 2135.248,463.586 2135.248,468.082 2108.267,452.381  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2108.317,457.494 2135.248,473.043 2135.248,477.539 2108.267,461.837  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2065.335,355.369 2065.335,507.551 2062.501,509.819 1976.889,457.091 1974.054,307.177  1976.889,304.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1974.054,307.177 1974.054,459.359 2062.501,509.819 2062.501,357.637  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1974.054,307.177 1974.054,328.155 2062.501,378.614 2062.501,357.637  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1983.236,349.913 1983.278,356.892 2031.334,384.733 2031.04,377.561  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2007.285,408.075 2007.327,415.053 2055.383,442.895 2055.088,435.723  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2036.857,381.016 2036.857,387.781 2054.92,398.254 2054.92,391.493  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1991.005,384.535 1991.005,391.3 2009.068,401.773 2009.068,395.012  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1985.158,396.626 1985.158,403.39 2003.221,413.864 2003.221,407.103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2012.935,381.016 2054.879,405.233 2054.879,412.235 2012.857,387.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2012.935,395.745 2054.879,419.961 2054.879,426.964 2012.857,402.509  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1983.236,410.889 1983.278,417.867 2031.334,445.709 2031.04,438.537  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2007.285,456.856 2007.327,463.834 2055.383,491.676 2055.088,484.503  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2036.857,441.992 2036.857,448.757 2054.92,459.23 2054.92,452.469  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1991.005,433.316 1991.005,440.08 2009.068,450.554 2009.068,443.793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1985.158,445.406 1985.158,452.171 2003.221,462.644 2003.221,455.883  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2012.935,444.526 2054.879,468.742 2054.879,475.744 2012.857,451.29  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1780.955,477.159 1776.56,479.732 1767.106,485.268 1749.641,495.492 1749.641,503.231  1767.106,493.006 1776.56,487.47 1780.955,484.897  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F02098"
    },
    points: "1828.757,468.22 1820.599,472.995 1809.423,479.538 1791.476,490.048 1777.978,497.95  1777.978,505.688 1791.476,497.786 1809.423,487.276 1820.599,480.733 1828.757,475.959 1832.042,474.033 1832.042,466.295  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1775.597,499.344 1767.106,504.316 1749.641,514.541 1749.641,522.279 1767.106,512.055  1775.597,507.082  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1789.884,521.934 1776.56,529.734 1767.106,535.27 1749.641,545.494 1749.641,553.233  1767.106,543.008 1776.56,537.472 1789.884,529.672  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1828.757,499.174 1820.599,503.948 1809.423,510.491 1792.265,520.54 1792.265,528.278  1809.423,518.23 1820.599,511.687 1828.757,506.912 1832.042,504.987 1832.042,497.249  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1802.384,499.137 1791.476,505.525 1776.56,514.257 1767.859,519.352 1767.859,527.091  1776.56,521.995 1791.476,513.263 1802.384,506.875  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1765.478,520.746 1749.641,530.018 1749.641,537.756 1765.478,528.485  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1828.757,483.697 1820.599,488.472 1809.423,495.015 1804.765,497.742 1804.765,505.481  1809.423,502.753 1820.599,496.21 1828.757,491.435 1832.042,489.51 1832.042,481.772  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1839.725,368.472 1839.673,377.205 1779.531,412.049 1779.9,403.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1809.628,441.261 1809.576,449.995 1749.434,484.838 1749.802,475.862  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F02098"
    },
    points: "1772.619,407.397 1772.619,415.863 1750.013,428.97 1750.013,420.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F02098"
    },
    points: "1830.003,411.801 1830.003,420.267 1807.397,433.375 1807.397,424.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1837.32,426.932 1837.32,435.398 1814.714,448.505 1814.714,440.044  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1863.509,411.801 1863.509,420.267 1840.903,433.375 1840.903,424.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1802.558,407.397 1750.065,437.704 1750.065,446.467 1802.655,415.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1802.558,425.83 1750.065,456.137 1750.065,464.9 1802.655,434.296  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1897.696,420.535 1897.696,382.81 1864.543,402.093 1864.543,440.156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1936.704,398.431 1936.704,360.706 1903.551,379.988 1903.551,418.052  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1897.696,467.345 1897.696,429.62 1864.543,448.903 1864.543,486.966  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1936.704,445.241 1936.704,407.515 1903.551,426.798 1903.551,464.862  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1900.772,771.219 1900.43,771.418 1845.881,802.914 1845.538,802.715  1790.996,771.219 1807.613,761.485 1845.114,739.53 1883.918,761.622 1900.436,771.025  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1845.881,745.547 1845.538,764.678 1845.307,777.567 1790.996,746.364 1790.996,733.182  1807.613,723.448  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23477C"
    },
    points: "1900.436,732.989 1900.43,733.381 1900.199,746.364 1845.307,777.567 1845.538,764.678  1845.881,745.547 1883.918,723.585  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1900.772,733.182 1900.43,733.381 1845.881,764.877 1845.538,764.678 1790.996,733.182  1807.613,723.448 1845.114,701.493 1883.918,723.585 1900.436,732.989  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD561"
    },
    points: "1808.358,733.127 1845.175,711.572 1883.224,733.235 1845.882,754.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "1813.321,733.112 1845.193,714.453 1878.209,733.251 1845.882,751.916  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1838.395,733.168 1845.635,728.929 1853.135,733.2 1845.792,737.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1845.193,716.947 1876.034,734.507 1878.209,733.251 1845.193,714.453 1813.321,733.112  1815.465,734.351  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1725.668,730.992 1764.808,708.074 1805.057,730.992 1765.362,753.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "1725.668,693.94 1764.808,671.023 1805.057,693.94 1765.362,716.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1725.668,717.451 1725.668,693.94 1765.362,716.858 1764.946,740.015  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1805.057,693.94 1765.362,716.858 1764.946,740.015 1804.641,717.451  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1725.252,652.895 1764.392,629.978 1804.641,652.895 1764.946,675.812  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1725.252,676.405 1725.252,652.895 1764.946,675.812 1764.53,698.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1804.641,652.895 1764.946,675.812 1764.53,698.97 1804.224,676.405  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1982.255,611.143 2041.782,645.824 1941.363,704.315 1882.353,669.117  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2010.207,
    y: 573.685,
    transform: "matrix(0.5003 -0.8658 0.8658 0.5003 480.4514 2045.0461)",
    style: {
      fill: "#77B8E0"
    },
    width: 3.623,
    height: 65.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2039.711,647.937c1.143,0,2.071-0.927,2.071-2.07v-65.738c0-1.143-0.927-2.07-2.071-2.07 s-2.071,0.927-2.071,2.07v65.738C2037.641,647.01,2038.568,647.937,2039.711,647.937z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M2042.386,632.408v13.372c0,1.477-1.198,2.674-2.674,2.674s-2.674-1.198-2.674-2.674v-13.372 H2042.386z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1884.424,671.23c1.143,0,2.07-0.927,2.07-2.07v-65.738c0-1.143-0.927-2.07-2.07-2.07 s-2.071,0.927-2.071,2.07v65.738C1882.353,670.303,1883.28,671.23,1884.424,671.23z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1887.098,655.701v13.372c0,1.477-1.197,2.674-2.674,2.674s-2.674-1.198-2.674-2.674v-13.372 H1887.098z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1941.363,704.876c1.143,0,2.071-0.927,2.071-2.07v-65.738c0-1.143-0.927-2.07-2.071-2.07 s-2.07,0.927-2.07,2.07v65.738C1939.292,703.949,1940.219,704.876,1941.363,704.876z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1982.255,548.553 2041.782,577.54 2041.782,583.234 1941.363,641.726 1882.353,606.527  1882.353,600.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1982.255,542.859 2041.782,577.54 1941.363,636.032 1882.353,600.833  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1944.037,689.347v13.372c0,1.477-1.198,2.674-2.674,2.674s-2.674-1.197-2.674-2.674v-13.372 H1944.037z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1910.823,
    y: 632.694,
    transform: "matrix(0.5003 -0.8658 0.8658 0.5003 379.6789 1988.4601)",
    style: {
      fill: "#77B8E0"
    },
    width: 3.623,
    height: 65.167
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#052754"
    },
    cx: 1970.761,
    cy: 608.319,
    r: 2.181
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#052754"
    },
    points: "1961.87,584.33 1944.759,594.395 1926.977,602.112 1926.977,604.796 1953.147,619.558  1970.593,609.493 1988.04,599.428 1988.04,596.744  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1971.696,607.632 1985.239,591.187 1986.206,596.991  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1985.239,591.187 1982.737,594.228 1971.786,607.522 1971.696,607.632 1946.806,593.189  1946.832,593.164 1947.067,592.941 1962.667,577.967  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1971.696,607.632 1970.99,607.722 1953.961,609.889 1934.266,598.948 1927.843,595.379  1946.397,593.215 1946.832,593.164 1946.858,593.16 1947.19,593.122  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1971.786,607.522 1971.696,607.632 1970.99,607.722 1946.58,593.325 1946.397,593.215  1946.832,593.164 1947.067,592.941 1947.148,592.989  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1927.843,595.379 1927.843,601.736 1953.961,616.338 1953.961,609.889  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1953.961,609.889 1953.961,616.338 1971.696,607.632  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "2034.728,689.458 2002.94,708.055 1970.347,687.758 2002.448,670.248  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M1959.291,676.635c0.632-2.213,10.432-2.845,10.432-2.845l9.167,4.109 c-0.316,5.058-1.264,6.322-3.477,6.322c-14.541-1.581-16.121-4.426-16.121-4.426S1958.658,678.848,1959.291,676.635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M1975.164,671.051c0.632-2.213,10.432-2.845,10.432-2.845l9.167,4.109 c-0.316,5.058-1.264,6.322-3.477,6.322c-14.541-1.581-16.122-4.425-16.122-4.425S1974.532,673.264,1975.164,671.051z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M1994.672,622.076l-14.816,8.093l-0.275,3.58l-1.102,44.214c-6.067,3.524-8.279-1.701-8.279-1.701 l-3.256-44.457l0,0c0.141-3.295,2.603-6.026,5.866-6.507L1994.672,622.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M1994.542,673.012c-5.719,4.059-8.392-0.948-8.392-0.948l-6.294-41.897l-0.373-2.114l-0.089-1.928 h12.815l0.032,2.722L1994.542,673.012z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2001.905,709.091c-0.572,0-1.035-0.464-1.035-1.035v-36.782c0-0.572,0.464-1.035,1.035-1.035 s1.035,0.464,1.035,1.035v36.782C2002.94,708.627,2002.476,709.091,2001.905,709.091z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M2000.567,702.107v6.687c0,0.738,0.599,1.337,1.337,1.337c0.739,0,1.337-0.599,1.337-1.337v-6.687 H2000.567z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2035.763,690.494c-0.572,0-1.035-0.464-1.035-1.035v-36.782c0-0.572,0.464-1.035,1.035-1.035 s1.035,0.464,1.035,1.035v36.782C2036.798,690.03,2036.335,690.494,2035.763,690.494z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M2034.426,683.51v6.687c0,0.739,0.599,1.337,1.337,1.337s1.337-0.599,1.337-1.337v-6.687H2034.426 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1970.287,690.885c-0.572,0-1.035-0.464-1.035-1.035v-36.782c0-0.572,0.464-1.035,1.035-1.035 c0.572,0,1.035,0.464,1.035,1.035v36.782C1971.323,690.421,1970.859,690.885,1970.287,690.885z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D1EA"
    },
    d: "M2003.853,671.958L2003.853,671.958c-0.139,0.767-0.639,1.347-1.272,1.637 c-0.633,0.29-1.399,0.289-2.071-0.106l-31.42-18.482v-3.16L2003.853,671.958z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "2010.478,637.913 2001.411,633.317 1969.234,651.991 2001.411,670.952  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1968.95,683.901v6.687c0,0.739,0.599,1.337,1.337,1.337s1.337-0.599,1.337-1.337v-6.687H1968.95z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CAAB"
    },
    d: "M1972.954,603.575c0,0,0.897-2.818-0.366-4.388c-1.263-1.57-2.504,0.767-2.504,0.767 c-4.877-3.788-5.87-1.919-5.87-1.919c-3.139,2.526-1.876,4.096-1.876,4.096c0.891,2.27,7.199,5.62,7.199,5.62L1972.954,603.575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M2024.549,570.531c3.46-0.346,6.494,1.404,7.425,10.702c0.931,9.298,0.643,25.467,0.643,25.467 l-6.301,29.097l-6.951-0.931l2.954-29.484l-3.27-23.15C2019.049,582.233,2017.629,571.224,2024.549,570.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1249A"
    },
    d: "M2015.696,657.713c-22.664,12.794-46.433-18.139-48.461-20.856 c-0.091-0.13-0.143-0.195-0.143-0.195l3.315-4.096c2.211-2.73,4.837-5.045,7.737-6.866c5.682-3.576,12.43-5.305,19.296-4.772 l30.777-5.526c0.26,0.689,0.507,1.365,0.728,2.041C2038.932,646.868,2015.696,657.713,2015.696,657.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#F1249A"
    },
    d: "M2015.696,657.713c-22.664,12.794-46.433-18.139-48.461-20.856 c29.633,18.204,52.765,17.671,61.711-19.413C2038.932,646.868,2015.696,657.713,2015.696,657.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC400"
    },
    d: "M1995.24,587.771l2.656,10.427c2.565,10.069,1.628,20.712-2.656,30.179l0,0 c0,0,25.922,4.128,35.956-9.967l-0.552-3.309c-2.607-7.41-3.413-15.334-2.351-23.117l2.351-17.236c0,0-0.395-2.632-2.628-4.839 c-1.129-1.115-2.563-1.782-4.063-1.98c-1.5-0.198-3.066,0.074-4.459,0.835l-19.204,10.495c-1.26,0.689-2.327,1.633-3.152,2.75 C1995.926,583.648,1995.24,585.66,1995.24,587.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M1999.207,581.058c3.472,0.187,6.203,2.381,5.701,11.712c-0.293,5.443-2.084,16.712-3.526,25.158 c-0.879,5.15-6.643,7.82-11.143,5.166l-21.521-14.79l4.86-6.481l17.822,9.721l0.583-19.763 C1991.982,591.782,1992.262,580.685,1999.207,581.058z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M1999.077,548.202c0,0-2.213,24.34,7.27,22.128c9.483-2.213,12.012-13.593,12.012-13.593 l-6.638-8.535H1999.077z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CAAB"
    },
    d: "M2008.718,564.789l-0.948,10.115c0,0,7.271,2.213,10.432-1.264v-8.851H2008.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CAAB"
    },
    d: "M2002.608,558.842c0,1.973,1.599,3.572,3.572,3.572c1.973,0,3.572-1.599,3.572-3.572 s-1.599-3.572-3.572-3.572C2004.207,555.27,2002.608,556.869,2002.608,558.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M2020.476,550.297c-0.216-1.314-0.587-2.562-1.169-3.676c-3.793-7.271-16.121-6.322-16.121-6.322 s-6.322,1.265-6.322,5.69c0,3.012,2.486,4.996,4.077,5.958c3.654,14.766-6.252,20.441-6.252,20.441s15.994,8.824,25.922-0.551 C2028.179,564.688,2023.248,554.661,2020.476,550.297z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2001.124,670.665 2012.041,625.847 2045.655,604.587 2048.384,606.454 2034.45,651.416  2003.853,672.245  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "2003.997,672.389 2014.914,627.571 2048.528,606.311 2037.323,653.14  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1897.696,373.725 1897.696,336 1864.543,355.283 1864.543,393.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1936.704,351.621 1936.704,313.896 1903.551,333.178 1903.551,371.242  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22,
      fill: "#15325C"
    },
    d: "M2313.068,741.841l325.902-188.159c3.7-2.136,8.256-2.143,11.963-0.018 l187.101,107.27c8.005,4.59,8.046,16.122,0.073,20.768l-69.252,40.357c-7.933,4.623-7.942,16.081-0.016,20.716l39.521,23.113 c8.039,4.701,7.886,16.371-0.273,20.862L2581.737,911.31c-3.68,2.025-8.151,1.978-11.787-0.125L2313.06,762.61 C2305.071,757.99,2305.075,746.455,2313.068,741.841z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M2917.995,686.579l-0.299-0.199c-0.149,0.232-0.348,0.448-0.614,0.605l-93.393,53.914 c-0.257,0.149-0.539,0.232-0.821,0.241c-0.348,0.016-0.705-0.066-1.012-0.249l-23.759-14.003 c-0.672-0.398-0.946-1.112-0.863-1.792l-0.025-0.008v-15.953l12.087,8.155l13.572-7.839l68.39-39.479 c0.556-0.323,1.253-0.323,1.817,0l8.528,4.928l16.343-5.168L2917.995,686.579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M2822.868,709.45v31.69c-0.348,0.016-0.705-0.066-1.012-0.249l-23.759-14.003 c-0.672-0.398-0.946-1.112-0.863-1.792l-0.025-0.008v-15.953l12.087,8.155L2822.868,709.45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2798.101,710.833l23.754,14.005c0.565,0.333,1.265,0.336,1.833,0.008l93.391-53.919 c1.212-0.7,1.212-2.45,0-3.15l-24.005-13.859c-0.563-0.325-1.256-0.325-1.818,0l-93.139,53.774 C2796.909,708.387,2796.902,710.125,2798.101,710.833z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2798.101,710.351l23.754,14.005c0.565,0.333,1.265,0.336,1.833,0.008l93.391-53.919 c1.212-0.7,1.212-2.45,0-3.15l-24.005-13.859c-0.563-0.325-1.256-0.325-1.818,0l-93.139,53.774 C2796.909,707.906,2796.902,709.644,2798.101,710.351z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M2881.208,647.751l-0.299-0.199c-0.149,0.232-0.349,0.448-0.614,0.606l-93.393,53.914 c-0.257,0.149-0.539,0.232-0.821,0.24c-0.348,0.017-0.705-0.066-1.012-0.249l-23.759-14.003 c-0.672-0.398-0.946-1.112-0.863-1.792l-0.025-0.008v-15.953l12.087,8.155l13.572-7.839l68.39-39.479 c0.556-0.323,1.253-0.323,1.817,0l8.528,4.928l16.343-5.168L2881.208,647.751z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M2786.082,670.622v31.69c-0.348,0.017-0.705-0.066-1.012-0.249l-23.759-14.003 c-0.672-0.398-0.946-1.112-0.863-1.792l-0.025-0.008v-15.953l12.087,8.155L2786.082,670.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2761.315,672.005l23.754,14.005c0.565,0.333,1.265,0.336,1.833,0.008l93.391-53.919 c1.212-0.7,1.212-2.45,0-3.15l-24.005-13.859c-0.563-0.325-1.256-0.325-1.818,0l-93.139,53.774 C2760.123,669.559,2760.115,671.297,2761.315,672.005z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2761.315,671.523l23.754,14.005c0.565,0.333,1.265,0.336,1.833,0.008l93.391-53.919 c1.212-0.7,1.212-2.45,0-3.15l-24.005-13.859c-0.563-0.325-1.256-0.325-1.818,0l-93.139,53.774 C2760.123,669.078,2760.115,670.816,2761.315,671.523z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M2844.06,563.418v39.979l-0.039-0.026c-0.288,3.688-2.25,7.258-5.911,9.39l-69.249,40.359 c-7.938,4.63-7.951,16.073-0.026,20.729l21.802,12.751l7.898-17.25l15.681,2.864v33.676c0.091,0.876,0.105,1.766,0,2.668v0.078 l-0.013-0.013c-0.379,3.649-2.419,7.167-6.12,9.181l-17.93,9.874l-3.453,1.883l-4.159,2.302l-4.865,2.694L2581.74,842.386 c-2.943,1.621-6.421,1.909-9.547,0.876c-0.771-0.262-1.517-0.589-2.236-1.007l-133.501-77.213l-4.852-2.812l-4.172-2.406 l-3.427-2.001l-110.941-64.148c-3.191-1.844-5.074-4.786-5.728-7.964v-0.013c-0.313-1.582-0.353-3.217-0.039-4.8v-0.04 c0-0.013,0.013-0.013,0.013-0.026l-0.235-35.925l20.415,19.669l147.01-84.89l164.457-94.96c3.701-2.119,8.278-2.119,11.979,0 l166.445,95.43l11.757-15.079L2844.06,563.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M2572.193,579.687v263.575c-0.771-0.262-1.517-0.589-2.236-1.007l-133.501-77.213l-4.852-2.812 l-4.172-2.406l-3.427-2.001l-110.941-64.148c-3.191-1.844-5.074-4.786-5.728-7.964v-0.013c-0.313-1.582-0.353-3.217-0.039-4.8 v-0.04c0-0.013,0.013-0.013,0.013-0.026l-0.235-35.925l20.415,19.669l147.01-84.89H2572.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2313.068,636.518l325.902-188.159c3.7-2.136,8.256-2.143,11.963-0.018l187.101,107.27 c8.005,4.59,8.046,16.122,0.073,20.768l-69.252,40.357c-7.933,4.623-7.942,16.081-0.016,20.716l39.521,23.113 c8.039,4.701,7.886,16.371-0.273,20.862l-226.348,124.561c-3.68,2.025-8.151,1.978-11.787-0.125l-256.89-148.575 C2305.071,652.668,2305.075,641.133,2313.068,636.518z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2728.905,724.568 2729.395,760.683 2764.453,741.39 2763.963,705.275  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2703.846,738.791 2703.846,775.175 2714.412,769.36 2714.412,732.976  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2523.849,545.437l-74.213,42.307c-1.698,0.968-1.706,3.412-0.015,4.391 l59.189,34.279c1.287,0.745,2.874,0.746,4.162,0.003l74.461-42.99c1.429-0.825,1.428-2.887-0.001-3.711l-59.448-34.269 C2526.705,544.709,2525.131,544.706,2523.849,545.437z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A34B73"
    },
    d: "M2537.427,533.756l-40.242,23.394l-4.077-1.931c0.386-0.66,0.94-1.222,1.621-1.618l36.083-20.996 c1.179-0.686,2.612-0.749,3.844-0.173L2537.427,533.756z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183561"
    },
    d: "M2576.944,578.995v-6.455l-4.565,2.85l-45.936-26.48c-1.067-0.615-2.38-0.618-3.45-0.008 l-58.505,33.352l-4.572-2.694v7.134l0.148-0.112c0.134,0.514,0.461,0.986,0.984,1.289l49.394,28.606 c1.074,0.622,2.398,0.623,3.473,0.002l62.139-35.876C2576.671,580.249,2576.966,579.617,2576.944,578.995z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EFFB"
    },
    d: "M2522.952,541.909l-61.932,35.306c-1.417,0.808-1.424,2.847-0.012,3.664l49.394,28.606 c1.074,0.622,2.398,0.623,3.473,0.002l62.139-35.876c1.192-0.688,1.191-2.409-0.001-3.097l-49.61-28.598 C2525.335,541.302,2524.022,541.299,2522.952,541.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183561"
    },
    d: "M2539.944,529.925l-4.865,36.445l-33.079,26.966l-4.943-2.785 c-0.645-0.307-1.174-0.785-1.54-1.364c-0.366-0.579-0.572-1.263-0.572-1.976l0.069-33.567c0-0.808,0.216-1.583,0.61-2.256 c0.386-0.661,0.94-1.222,1.621-1.618l36.083-20.996c1.179-0.686,2.612-0.749,3.844-0.173L2539.944,529.925z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "2544.019,528.393 2543.906,569.009 2501.782,593.337 2501.82,552.946  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D1EA"
    },
    d: "M2613.821,277.206l9.767,5.259l-14.607,195.511L2406.728,609.44l-8.024-4.321 c-2.027-1.092-3.673-2.696-4.812-4.603c-1.139-1.907-1.771-4.117-1.771-6.419V407.126c0-1.721,0.456-3.377,1.284-4.82 c0.827-1.443,2.026-2.674,3.511-3.543l207.321-121.385c1.278-0.748,2.684-1.184,4.112-1.306 C2610.215,275.912,2612.118,276.289,2613.821,277.206z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "2623.588,282.465 2623.588,485.841 2406.728,609.44 2406.728,409.435  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2619.094,307.117 2619.094,470.155 2593.426,484.782 2585.718,489.18 2533.019,519.215  2503.827,535.849 2457.993,561.976 2413.47,587.353 2413.47,427.509 2457.051,401.995 2480.642,388.18 2517.864,366.39  2562.648,340.163 2590.537,323.835 2610.896,311.921  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2727.981,620.924l-78.814-45.918c-1.55-0.903-3.466-0.909-5.021-0.014 l-169.835,97.673c-3.347,1.925-3.352,6.753-0.008,8.684l74.172,42.841c4.861,2.808,10.851,2.808,15.713,0l163.778-94.596 c1.938-1.119,2.751-3.212,2.44-5.149C2730.181,623.049,2729.373,621.735,2727.981,620.924z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D1EA"
    },
    d: "M2730.041,608.288l-83.381-44.007l-170.784,92.949c-2.292,1.247-3.752,3.614-3.839,6.222 l-0.091,2.725c-0.045,1.36,0.282,2.677,0.913,3.827c0.643,1.173,1.602,2.172,2.803,2.866l75.318,43.503 c3.311,1.912,7.39,1.912,10.7,0l165.323-95.488c0.98-0.566,1.771-1.371,2.318-2.316c0.569-0.983,0.873-2.118,0.851-3.294 L2730.041,608.288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EFFB"
    },
    d: "M2727.981,606.255l-78.814-45.918c-1.55-0.903-3.466-0.909-5.021-0.014l-169.835,97.673 c-3.347,1.925-3.352,6.753-0.008,8.684l74.172,42.84c4.861,2.808,10.851,2.808,15.713,0l163.778-94.596 c1.938-1.119,2.751-3.212,2.44-5.149C2730.181,608.38,2729.373,607.066,2727.981,606.255z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2715.499,614.207 2640.407,570.457 2488.264,657.956 2564.009,701.705  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2665.666,616.171 2648.341,626.135 2635.231,618.595 2652.556,608.631  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2681.563,625.313 2664.237,635.277 2651.128,627.737 2668.453,617.773  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2645.553,627.737 2628.231,637.7 2615.12,630.161 2632.444,620.198  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2629.656,618.595 2612.333,628.558 2599.223,621.019 2616.547,611.056  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2570.679,674.004 2588.004,664.04 2601.114,671.58 2583.789,681.544  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2590.791,662.438 2648.341,629.34 2661.45,636.88 2603.9,669.977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2655.343,607.028 2672.469,597.179 2685.494,604.767 2668.453,614.568  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2554.782,664.862 2572.107,654.898 2585.217,662.438 2567.892,672.401  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2639.446,597.886 2656.675,587.977 2669.7,595.566 2652.556,605.425  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2609.545,630.162 2592.224,640.123 2579.114,632.584 2596.435,622.622  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2625.442,639.304 2608.122,649.265 2595.011,641.726 2612.332,631.765  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2558.998,644.153 2576.323,634.189 2589.432,641.728 2572.107,651.692  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2574.894,653.295 2592.219,643.331 2605.328,650.871 2588.004,660.835  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2534.67,676.429 2551.995,666.465 2565.104,674.004 2547.779,683.968  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2550.566,685.571 2567.892,675.607 2581.001,683.147 2563.676,693.11  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2518.773,667.286 2536.098,657.322 2549.208,664.862 2531.882,674.826  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2502.876,658.144 2520.201,648.18 2533.311,655.719 2515.986,665.683  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2684.35,623.71 2671.24,616.17 2688.263,606.38 2701.288,613.969  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2636.659,596.283 2623.55,588.744 2640.875,578.78 2641.932,579.388 2653.906,586.364  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2522.988,646.577 2540.314,636.613 2553.423,644.153 2536.098,654.117  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2573.536,632.586 2556.21,642.55 2543.101,635.01 2560.427,625.046  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2538.885,655.72 2556.21,645.756 2569.32,653.295 2551.995,663.259  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2593.647,621.019 2576.326,630.981 2563.216,623.442 2580.538,613.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2633.872,597.886 2616.547,607.85 2603.437,600.31 2620.763,590.346  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2613.76,609.453 2596.435,619.416 2583.325,611.877 2600.65,601.913  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "2649.769,607.028 2632.444,616.992 2619.334,609.453 2636.659,599.489  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183561"
    },
    d: "M2687.279,558.148c0.165,0.784,0.743,1.734,1.651,2.787c5.264,6.007,21.695,15.337,34.535,18.288 c5.49,1.28,10.321,1.383,13.354-0.433c10.321-6.193,8.257-24.77-12.385-33.027 C2703.792,537.506,2685.215,547.827,2687.279,558.148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2688.93,560.935c5.264,6.007,21.695,15.337,34.535,18.288 C2715.104,559.737,2697.909,559.51,2688.93,560.935z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2710.907,547.646l-18.352-0.333 C2703.187,543.013,2710.907,547.646,2710.907,547.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2570.063,411.114 2570.011,419.847 2509.869,454.691 2510.237,445.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2539.966,483.903 2539.914,492.637 2479.772,527.48 2480.14,518.504  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F02098"
    },
    points: "2502.956,450.039 2502.956,458.505 2480.351,471.612 2480.351,463.151  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F02098"
    },
    points: "2560.34,454.443 2560.34,462.909 2537.735,476.017 2537.735,467.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2567.658,469.574 2567.658,478.04 2545.052,491.147 2545.052,482.686  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2593.847,454.443 2593.847,462.909 2571.241,476.017 2571.241,467.555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2532.896,450.039 2480.403,480.346 2480.403,489.109 2532.993,458.505  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2532.896,468.472 2480.403,498.779 2480.403,507.542 2532.993,476.938  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    cx: 2653.077,
    cy: 510.039,
    rx: 37.117,
    ry: 21.614
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A302"
    },
    d: "M2615.959,488.787c0,11.937,16.618,21.615,37.118,21.615c5.213,0,10.176-0.626,14.677-1.756 c0.867-0.217,1.715-0.453,2.545-0.706c0.869-0.267,1.719-0.552,2.545-0.855c2.825-1.037,5.393-2.291,7.636-3.72 c6.033-3.843,9.713-8.961,9.713-14.578v-0.012h0.007v-9.689h-3.948c-1.538-1.78-3.487-3.419-5.772-4.875 c-2.243-1.429-4.811-2.683-7.636-3.72c-0.826-0.304-1.676-0.588-2.545-0.855c-0.831-0.253-1.678-0.489-2.545-0.706 c-4.501-1.131-9.463-1.756-14.677-1.756c-14.508,0-27.072,4.847-33.177,11.912h-3.938v9.438 C2615.961,488.612,2615.959,488.7,2615.959,488.787z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -0.002 0.002 1 -0.9475 5.2563)",
    style: {
      fill: "#FEC400"
    },
    cx: 2653.077,
    cy: 480.977,
    rx: 37.117,
    ry: 21.614
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD561"
    },
    cx: 2653.077,
    cy: 480.977,
    rx: 31.399,
    ry: 18.284
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2646.582,494.49c-1.23,0-2.312-0.894-2.511-2.147c-0.22-1.388,0.727-2.693,2.115-2.913 l10.006-1.587l-3.46-19.899c-0.241-1.385,0.687-2.703,2.072-2.944c1.382-0.243,2.703,0.686,2.944,2.072l4.346,24.989 l-15.11,2.398C2646.849,494.48,2646.714,494.49,2646.582,494.49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    cx: 2570.929,
    cy: 761.412,
    rx: 37.117,
    ry: 21.614
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A302"
    },
    d: "M2533.811,740.161c0,11.937,16.618,21.615,37.118,21.615c5.213,0,10.176-0.626,14.677-1.756 c0.867-0.217,1.715-0.453,2.545-0.706c0.869-0.267,1.719-0.552,2.545-0.855c2.825-1.037,5.393-2.291,7.636-3.72 c6.033-3.843,9.713-8.961,9.713-14.578v-0.012h0.007v-9.689h-3.948c-1.538-1.78-3.487-3.419-5.772-4.875 c-2.243-1.429-4.811-2.683-7.636-3.72c-0.826-0.304-1.676-0.588-2.545-0.855c-0.831-0.253-1.678-0.489-2.545-0.706 c-4.501-1.131-9.463-1.756-14.677-1.756c-14.508,0-27.072,4.847-33.177,11.912h-3.938v9.438 C2533.813,739.985,2533.811,740.074,2533.811,740.161z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(1 -0.002 0.002 1 -1.4448 5.0911)",
    style: {
      fill: "#FEC400"
    },
    cx: 2570.929,
    cy: 732.351,
    rx: 37.117,
    ry: 21.614
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFD561"
    },
    cx: 2570.929,
    cy: 732.351,
    rx: 31.399,
    ry: 18.284
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2564.434,745.864c-1.23,0-2.312-0.894-2.511-2.147c-0.22-1.388,0.727-2.693,2.115-2.913 l10.006-1.587l-3.46-19.899c-0.241-1.385,0.687-2.703,2.072-2.944c1.382-0.243,2.703,0.687,2.944,2.072l4.346,24.988 l-15.11,2.398C2564.701,745.853,2564.566,745.864,2564.434,745.864z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2327.247,573.521 2327.247,632.865 2330.828,634.912 2427.518,573.521 2431.099,517.247  2427.518,515.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2330.828,575.568 2330.828,634.912 2431.099,575.568 2431.099,517.247  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2358.326,573.974 2361.294,572.237 2361.294,567.01 2358.326,568.748 2351.941,572.487  2340.146,579.392 2340.146,584.618 2351.941,577.713  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2357.676,587.219 2357.676,581.993 2351.941,585.351 2340.146,592.256  2340.146,597.483 2351.941,590.577  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2351.941,606.256 2340.146,613.161 2340.146,618.388 2351.941,611.482 2358.326,607.743  2367.324,602.476 2367.324,597.249 2358.326,602.517  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2375.766,581.853 2368.4,586.167 2358.326,592.065 2352.449,595.506 2352.449,600.732  2358.326,597.291 2368.4,591.393 2375.766,587.079  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2350.841,596.447 2340.146,602.709 2340.146,607.935 2350.841,601.674  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2359.284,586.278 2368.4,580.941 2380.52,573.843 2386.379,570.413 2386.379,565.187  2380.52,568.617 2368.4,575.715 2359.284,581.051  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2393.578,560.973 2388.175,564.135 2388.175,569.361 2393.578,566.2 2422.748,549.627  2422.748,544.401  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2377.375,580.911 2377.375,586.137 2380.52,584.295 2388.068,579.877 2393.578,576.652  2403.448,571.044 2403.448,565.818 2393.578,571.426 2388.068,574.65 2380.52,579.069  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2405.244,570.024 2422.748,560.08 2422.748,554.853 2405.244,564.797  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2398.057,584.559 2422.748,570.532 2422.748,565.306 2398.057,579.333  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2388.068,585.103 2380.52,589.522 2368.932,596.308 2368.932,601.534 2380.52,594.748  2388.068,590.329 2393.578,587.104 2396.261,585.58 2396.261,580.354 2393.578,581.878  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2363.62,664.814l45.597-26.698c1.27-0.743,2.84-0.753,4.119-0.025l46.977,26.748 c2.765,1.574,2.777,5.555,0.021,7.146l-46.243,26.699c-1.274,0.736-2.844,0.736-4.119,0l-46.33-26.748 C2360.906,670.355,2360.894,666.41,2363.62,664.814z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2448.634,647.48 2412.411,668.393 2412.031,689.526 2448.254,668.934  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "2376.188,647.48 2411.905,626.566 2448.634,647.48 2412.411,668.393  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15325C"
    },
    points: "2391.869,647.48 2411.749,635.839 2432.193,647.48 2412.031,659.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2376.188,668.934 2376.188,647.48 2412.411,668.393 2412.031,689.526  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2429.31,638.354c-1.78,2.73-4.266,5.387-7.752,7.605c-8.067,6.484-22.594,4.899-26.666-2.9 c0,0-6.751-5.631-5.679-15.332c1.754,4.802,5.898,7.702,6.41,8.044c-6.654-5.679-2.413-22.303-2.413-22.303 s1.633,7.532,8.36,13.163c0,0-2.072-11.139,0.561-21.766c1.292-5.29,3.778-10.481,8.239-14.064 c-1.853,16.964,6.8,27.713,6.8,27.713c5.631-6.752,4.266-16.696,4.266-16.696s8.117,15.575,4.387,27.445 c5.094-1.901,8.044-6.483,8.044-6.483S2434.33,630.798,2429.31,638.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2429.31,638.354c-1.78,2.73-4.266,5.387-7.752,7.605 c-1.95,1.56-4.29,2.657-6.776,3.315c-7.726,2.048-16.794-0.317-19.889-6.215c0,0-6.751-5.631-5.679-15.332 c1.754,4.802,5.898,7.702,6.41,8.044c-6.654-5.679-2.413-22.303-2.413-22.303s0.683,3.12,2.949,6.825 c1.243,2.072,2.998,4.339,5.411,6.338c0,0-2.072-11.139,0.561-21.766C2402.107,628.702,2414.344,638.695,2429.31,638.354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2414.782,649.273c-7.726,2.048-16.794-0.317-19.889-6.215 c0,0-6.751-5.631-5.679-15.332c1.754,4.802,5.898,7.702,6.41,8.044c-6.654-5.679-2.413-22.303-2.413-22.303 s0.683,3.12,2.949,6.825C2398.427,637.355,2408.007,645.545,2414.782,649.273z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2406.158,630.986c0.923,1.417,2.213,2.795,4.022,3.946c4.186,3.364,11.723,2.542,13.836-1.505 c0,0,3.503-2.922,2.947-7.955c-0.91,2.491-3.061,3.996-3.326,4.173c3.452-2.947,1.252-11.572,1.252-11.572 s-0.847,3.908-4.338,6.83c0,0,1.075-5.78-0.291-11.294c-0.67-2.745-1.96-5.438-4.275-7.297 c0.961,8.802-3.528,14.379-3.528,14.379c-2.922-3.503-2.213-8.663-2.213-8.663s-4.212,8.081-2.277,14.24 c-2.643-0.986-4.174-3.364-4.174-3.364S2403.553,627.066,2406.158,630.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2406.158,630.986c0.923,1.417,2.213,2.795,4.022,3.946 c1.012,0.81,2.226,1.379,3.516,1.72c4.009,1.063,8.714-0.164,10.32-3.225c0,0,3.503-2.922,2.947-7.955 c-0.91,2.491-3.061,3.996-3.326,4.173c3.452-2.947,1.252-11.572,1.252-11.572s-0.354,1.619-1.53,3.541 c-0.645,1.075-1.555,2.251-2.808,3.288c0,0,1.075-5.78-0.291-11.294C2420.272,625.978,2413.923,631.164,2406.158,630.986z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#77B8E0"
    },
    d: "M2413.696,636.652c4.009,1.063,8.714-0.164,10.32-3.225c0,0,3.503-2.922,2.947-7.955 c-0.91,2.491-3.061,3.996-3.326,4.173c3.452-2.947,1.252-11.572,1.252-11.572s-0.354,1.619-1.53,3.541 C2422.182,630.468,2417.211,634.717,2413.696,636.652z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2380.183,546.805 2376.561,546.805 2376.561,522.228 2451.697,478.245 2453.525,481.372  2380.183,524.304  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2597.732,447.817 2596.573,445.78 2647.551,416.814 2647.551,384.679 2649.896,384.679  2649.896,418.179  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2738.411,380.91c1.261-5.721,4.184-9.944,8.464-11.296c4.616-1.458,9.859,0.73,14.426,5.365 c2.14-7.61,6.366-13.163,12.328-15.046c12.919-4.08,29.072,10.598,36.079,32.784c0.424,1.342,0.802,2.681,1.141,4.013 c6.907,2.099,13.928,10.355,17.446,21.493c1.583,5.012,2.25,9.954,2.101,14.393l0.735,0.422 c5.467,3.135,8.838,8.956,8.838,15.258v0c0,13.518-14.614,21.983-26.34,15.258l-87.385-50.118 c-5.467-3.135-8.838-8.956-8.838-15.258v0C2717.405,386.661,2728.017,378.818,2738.411,380.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2315.356,503.829c-0.923-4.187-3.062-7.277-6.194-8.266c-3.378-1.067-7.214,0.534-10.556,3.926 c-1.566-5.569-4.659-9.633-9.022-11.01c-9.455-2.986-21.275,7.756-26.403,23.991c-0.31,0.982-0.587,1.962-0.835,2.937 c-5.054,1.536-10.193,7.578-12.767,15.729c-1.158,3.668-1.646,7.284-1.537,10.533l-0.538,0.309 c-4,2.294-6.468,6.554-6.468,11.166l0,0c0,9.893,10.695,16.088,19.276,11.166l63.948-36.676 c4.001-2.294,6.468-6.554,6.468-11.166v0C2330.729,508.037,2322.963,502.298,2315.356,503.829z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2456.25,430.292 2460.946,427.542 2460.946,419.273 2456.25,422.022 2446.147,427.938  2427.485,438.864 2427.485,447.133 2446.147,436.207  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2455.221,451.249 2455.221,442.98 2446.147,448.293 2427.485,459.219 2427.485,467.488  2446.147,456.562  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2446.147,481.369 2427.485,492.295 2427.485,500.565 2446.147,489.639 2456.25,483.723  2470.487,475.388 2470.487,467.119 2456.25,475.454  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2483.845,442.758 2472.189,449.584 2456.25,458.915 2446.951,464.36 2446.951,472.629  2456.25,467.185 2472.189,457.853 2483.845,451.027  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2444.407,465.85 2427.485,475.757 2427.485,484.026 2444.407,474.119  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2607.451,333.024 2607.451,417.914 2609.849,419.832 2682.269,375.229 2684.667,292.257  2682.269,290.339  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2684.667,292.257 2684.667,377.148 2609.849,419.832 2609.849,334.942  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "2684.667,292.257 2684.667,310.003 2609.849,352.688 2609.849,334.942  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2679.479,325.83 2679.444,331.733 2638.792,355.285 2639.042,349.218  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2659.136,375.03 2659.101,380.933 2618.449,404.485 2618.698,398.418  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2634.12,352.141 2634.12,357.863 2618.84,366.723 2618.84,361.003  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2672.907,355.117 2672.907,360.84 2657.628,369.699 2657.628,363.98  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2677.854,365.345 2677.854,371.067 2662.574,379.927 2662.574,374.207  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2654.357,352.141 2618.875,372.626 2618.875,378.549 2654.423,357.863  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2654.357,364.6 2618.875,385.085 2618.875,391.008 2654.423,370.322  "
  }))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    cx: 2706.107,
    cy: 699.925,
    rx: 42.425,
    ry: 24.705
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183561"
    },
    d: "M2680.098,698.771l10.326,3.872v6.12c0,1.404-0.752,2.699-1.971,3.396l-0.588,0.336 c-1.214,0.694-2.707,0.687-3.914-0.019c-3.569-2.087-10.953-6.444-12.89-7.897 C2668.481,702.643,2669.126,695.544,2680.098,698.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#183561"
    },
    d: "M2729.038,698.128l9.414-5.745l4.82,3.772c1.105,0.865,1.662,2.256,1.459,3.645l-0.098,0.67 c-0.202,1.384-1.128,2.555-2.427,3.07c-3.843,1.524-11.826,4.653-14.163,5.282 C2724.927,709.663,2719.734,704.779,2729.038,698.128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15325C"
    },
    d: "M2718.628,594.861v56.473l22.75,40.983c0,0-4.485,9.036-11.133,6.454 c-2.387-3.227-28.559-39.531-29.689-46.308c-1.129-6.777-10.165-38.401-10.165-38.401v-19.201H2718.628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15325C"
    },
    d: "M2681.356,594.861c0,0-7.906,33.884-6.777,54.214s2.292,47.114,3.583,51.632 c3.873,6.454,13.198,2.582,13.198,2.582l-0.161-54.214l18.394-54.214H2681.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC69B9"
    },
    d: "M2697.697,521.859c3.854-1.354,7.804-0.196,11.444,10.162c3.639,10.359,7.792,28.901,7.792,28.901 l0.87,34.969l-8.194,0.864l-4.799-34.483l-10.15-25.527C2694.66,536.746,2689.988,524.568,2697.697,521.859z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2673.079,616.571c0,0-3.247,1.238-3.765,3.548c-0.518,2.31,2.538,1.74,2.538,1.74 c0.088,7.256,2.533,6.8,2.533,6.8c4.62,1.036,5.137-1.274,5.137-1.274c1.434-2.481-0.104-10.731-0.104-10.731L2673.079,616.571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F02098"
    },
    d: "M2668.698,549.743l14.231,57.943c0,0,30.45,5.22,38.353-17.659l-6.525-20.584l-9.245-44.384 c0,0-1.18-2.896-4.342-4.797c-1.598-0.961-3.42-1.325-5.188-1.135c-1.768,0.19-3.481,0.934-4.86,2.189l-19.019,17.306 c-1.248,1.136-2.205,2.51-2.837,4.013C2668.339,544.845,2668.113,547.332,2668.698,549.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EC69B9"
    },
    d: "M2671.678,540.903c4.016-0.749,7.743,0.999,9.755,11.792c2.013,10.793,3.281,29.752,3.281,29.752 l-4.487,34.691l-8.23-0.399l0.53-34.811l-6.127-26.779C2666.401,555.15,2663.646,542.401,2671.678,540.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2662.424,503.424c0,0,4.219,28.405,14.434,23.25c10.215-5.155,9.948-18.849,9.948-18.849 l-9.945-7.905L2662.424,503.424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2678.03,519.691l1.721,11.813c0,0,8.915,0.511,11.56-4.335l-2.453-10.106L2678.03,519.691z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M2671.462,512.314c-4.955,0.056-4.202-4.713-4.202-4.713s-6.749-1.037-7.976-6.09 s2.677-9.44,2.677-9.44l2.965,1.191c0,0,13.813-4.5,20.16,2.751c6.346,7.25,4.163,23.45,4.163,23.45l-6.121,1.486l-7.532-7.345 L2671.462,512.314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2669.405,514.594c0.547,2.253,2.816,3.635,5.069,3.089c2.253-0.547,3.635-2.816,3.089-5.069 c-0.547-2.253-2.816-3.635-5.069-3.089C2670.241,510.072,2668.858,512.341,2669.405,514.594z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22,
      fill: "#15325C"
    },
    d: "M2748.98,1493.342l-61.192,35.662c-7.008,4.09-7.02,14.212-0.011,18.302 l34.916,20.428c7.1,4.159,6.974,14.465-0.242,18.429l-200.002,110.066c-3.251,1.792-7.193,1.746-10.409-0.115l-226.991-131.275 c-7.054-4.079-7.054-14.281,0.012-18.348l287.964-166.259c3.274-1.884,7.295-1.896,10.57-0.023l99.83,57.239l4.573,2.619 l5.733,3.286l4.584,2.631l50.598,29.01C2755.988,1479.049,2756.022,1489.24,2748.98,1493.342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M2754.242,1388.836v35.318l-0.035-0.023c-0.252,3.263-1.988,6.423-5.227,8.295l-49.334,28.757 l-11.845,6.905c-7.02,4.09-7.031,14.201-0.023,18.325l19.256,11.259l6.986-15.235l13.856,2.528v29.757 c0.08,0.77,0.092,1.563,0,2.356v0.069l-0.011-0.011c-0.333,3.229-2.137,6.33-5.412,8.111l-15.843,8.72l-3.045,1.666l-3.677,2.034 l-4.297,2.378l-23.082,12.707l-4.596,2.528l-5.745,3.16l-4.595,2.527l-27.218,14.971l-107.895,59.387 c-2.608,1.436-5.676,1.689-8.433,0.781c-0.689-0.241-1.344-0.529-1.976-0.896l-117.97-68.223l-4.286-2.482l-3.366-1.942 l-0.322-0.184l-3.021-1.769l-1.252-0.724l-5.744-3.32l-4.596-2.654l-86.433-49.989c-2.826-1.62-4.492-4.228-5.067-7.031v-0.012 c-0.276-1.402-0.31-2.849-0.034-4.239v-0.035c0-0.011,0.011-0.011,0.011-0.023l-0.195-29.562v-0.689 c-0.011-0.011-0.011-0.035,0-0.046l-0.011-1.448l0.126,0.126l17.911,17.245l129.896-75.001l145.315-83.905 c3.274-1.873,7.319-1.873,10.581,0l147.073,84.319l10.386-13.328l12.948-1.436L2754.242,1388.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M2514.027,1403.209v232.897c-0.689-0.241-1.344-0.529-1.976-0.896l-117.97-68.223l-4.286-2.482 l-3.366-1.942l-0.322-0.184l-3.021-1.769l-1.252-0.724l-5.744-3.32l-4.596-2.654l-86.433-49.989 c-2.826-1.62-4.492-4.228-5.067-7.031v-0.012c-0.276-1.402-0.31-2.849-0.034-4.239v-0.035c0-0.011,0.011-0.011,0.011-0.023 l-0.195-29.562v-0.689l-0.011-1.494l0.126,0.126l17.911,17.245l129.896-75.001H2514.027z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2748.98,1400.28l-61.192,35.662c-7.008,4.09-7.02,14.212-0.011,18.302l34.916,20.428 c7.1,4.159,6.974,14.465-0.242,18.429l-200.002,110.066c-3.251,1.792-7.193,1.746-10.409-0.115l-226.991-131.275 c-7.054-4.079-7.054-14.281,0.012-18.348l287.964-166.26c3.274-1.884,7.295-1.896,10.57-0.023l99.83,57.239l4.573,2.619 l5.733,3.286l4.584,2.631l50.598,29.01C2755.988,1385.987,2756.022,1396.178,2748.98,1400.28z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2652.49,1531.224 2652.923,1563.134 2683.901,1546.087 2683.468,1514.177  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2630.348,1543.791 2630.348,1575.939 2639.685,1570.802 2639.685,1538.653  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M2716.513,1448.813v22.891l0.121-0.088c0.341,2.021,1.516,3.921,3.537,5.086l76.921,44.408 c1.143,0.659,2.417,0.989,3.691,0.978c1.252-0.011,2.504-0.329,3.625-0.978l77.009-44.584c2.438-1.406,3.636-3.877,3.636-6.338 v-21.375l-16.147,7.854l-64.377-37.071c-2.263-1.296-5.042-1.296-7.305,0.011l-49.736,28.679l-12.906,7.436L2716.513,1448.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M2716.513,1448.813v22.891l0.121-0.088c0.341,2.021,1.516,3.921,3.537,5.086l76.921,44.408 c1.143,0.659,2.417,0.989,3.691,0.978v-27.559l-53.295-46.243l-12.906,7.436L2716.513,1448.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2804.532,1398.056l76.866,44.255c4.881,2.81,4.889,9.85,0.015,12.671l-77.002,44.581 c-2.265,1.311-5.057,1.313-7.323,0.004l-76.92-44.41c-4.879-2.817-4.877-9.86,0.004-12.674l77.055-44.426 C2799.488,1396.755,2802.271,1396.755,2804.532,1398.056z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2804.532,1397.368l76.866,44.255c4.881,2.81,4.889,9.85,0.015,12.671l-77.002,44.581 c-2.265,1.311-5.057,1.313-7.323,0.004l-76.92-44.41c-4.879-2.817-4.877-9.86,0.004-12.673l77.055-44.426 C2799.488,1396.067,2802.271,1396.066,2804.532,1397.368z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2698.313,1352.921 2584.972,1419.937 2577.366,1407.092 2683.423,1344.385  2687.995,1347.004 2693.728,1350.29  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2608.04,1203.442c1.115-5.055,3.697-8.787,7.479-9.981c4.079-1.288,8.711,0.645,12.746,4.741 c1.891-6.724,5.625-11.631,10.893-13.294c11.416-3.605,25.688,9.364,31.879,28.968c0.375,1.186,0.709,2.369,1.008,3.546 c6.103,1.855,12.307,9.149,15.415,18.992c1.398,4.428,1.988,8.795,1.856,12.718l0.65,0.373c4.831,2.77,7.81,7.913,7.81,13.482v0 c0,11.944-12.913,19.425-23.274,13.482l-77.213-44.284c-4.83-2.77-7.81-7.914-7.81-13.482l0,0 C2589.479,1208.523,2598.855,1201.594,2608.04,1203.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2296.1,1326.451c-0.619-2.808-2.053-4.88-4.154-5.543c-2.265-0.715-4.838,0.358-7.079,2.633 c-1.05-3.735-3.124-6.46-6.05-7.384c-6.34-2.002-14.267,5.201-17.706,16.089c-0.208,0.659-0.394,1.316-0.56,1.969 c-3.389,1.03-6.835,5.082-8.562,10.548c-0.777,2.46-1.104,4.885-1.031,7.063l-0.361,0.207c-2.683,1.539-4.338,4.395-4.338,7.488v0 c0,6.634,7.172,10.788,12.927,7.488l42.884-24.595c2.683-1.539,4.338-4.395,4.338-7.488v0 C2306.409,1329.273,2301.201,1325.424,2296.1,1326.451z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2514.843,1525.033l-135.11-77.206l133.41-80.747l1.483,0.885l133.629,79.831L2514.843,1525.033z  M2391.063,1447.685l123.762,70.721l122.098-70.69l-123.76-73.935L2391.063,1447.685z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2672.508,1520.077 2672.508,1552.752 2667.912,1555.28 2662.167,1558.439  2657.572,1560.967 2657.572,1528.694 2657.331,1528.556 2528.032,1453.876 2535.5,1440.94  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2515.968,1456.174 2514.027,1457.3 2386.934,1530.704 2386.428,1530.991  2386.428,1562.564 2386.106,1562.38 2383.084,1560.611 2381.832,1559.887 2376.088,1556.566 2371.492,1553.912 2371.492,1522.375  2372.021,1522.076 2508.5,1443.238 2514.027,1452.808  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1249A"
    },
    points: "2693.728,1350.29 2586.592,1413.653 2583.662,1408.701 2687.995,1347.004  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD561"
    },
    points: "2667.912,1522.731 2667.912,1555.28 2662.167,1558.439 2662.167,1526.04  2662.042,1525.971 2534.305,1452.199 2537.177,1447.224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F1249A"
    },
    points: "2509.695,1454.497 2382.338,1528.039 2381.832,1528.338 2381.832,1559.887  2376.088,1556.566 2376.088,1525.029 2376.605,1524.73 2506.823,1449.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.39,
      fill: "#77B8E0"
    },
    points: "2672.508,1519.79 2657.572,1528.981 2657.572,1561.151 2672.508,1553.108  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.39,
      fill: "#77B8E0"
    },
    points: "2371.492,1522.087 2386.428,1531.279 2386.428,1562.3 2371.492,1554.257  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2735.594,1443.572l60.584-35.474c1.688-0.988,3.774-1.001,5.473-0.033 l62.418,35.54c3.674,2.092,3.689,7.381,0.029,9.495l-61.444,35.475c-1.693,0.978-3.78,0.978-5.473,0l-61.558-35.541 C2731.988,1450.935,2731.972,1445.693,2735.594,1443.572z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2848.552,1420.541 2800.422,1448.328 2799.918,1476.407 2848.047,1449.047  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "2752.293,1420.541 2799.75,1392.753 2848.552,1420.541 2800.422,1448.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15325C"
    },
    points: "2773.129,1420.541 2799.543,1405.074 2826.707,1420.541 2799.918,1436.007  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2752.293,1449.047 2752.293,1420.541 2800.422,1448.328 2799.918,1476.407  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2792.012,
    y: 1378.356,
    style: {
      fill: "#15325C"
    },
    width: 13.25,
    height: 40.414
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#15325C"
    },
    points: "2798.637,1398.232 2821.826,1373.719 2824.476,1378.356 2799.962,1404.857  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2847.001,1370.737c0,2.074-0.311,4.074-0.895,5.963c-2.544,8.248-10.229,14.244-19.312,14.244 c-11.157,0-20.207-9.05-20.207-20.207c0-6.393,2.975-12.098,7.619-15.795c3.452-2.763,7.824-4.412,12.588-4.412 C2837.951,1350.531,2847.001,1359.58,2847.001,1370.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2846.107,1376.7c-1.086,3.518-3.107,6.632-5.777,9.043 c-3.584,3.233-8.328,5.201-13.535,5.201c-11.157,0-20.207-9.05-20.207-20.207c0-0.676,0.033-1.338,0.099-1.994 c0.55-5.578,3.366-10.494,7.52-13.8C2813.75,1376.276,2831.306,1378.211,2846.107,1376.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2840.33,1385.743c-3.584,3.233-8.328,5.201-13.535,5.201 c-11.157,0-20.207-9.05-20.207-20.207c0-0.676,0.033-1.338,0.099-1.994C2810.463,1382.855,2826.02,1387.466,2840.33,1385.743z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2831.101,1350.862c0,3.297-0.495,6.479-1.422,9.482c-4.045,13.116-16.266,22.651-30.71,22.651 c-17.741,0-32.132-14.391-32.132-32.132c0-10.166,4.73-19.237,12.115-25.116c5.489-4.393,12.442-7.016,20.017-7.016 C2816.71,1318.729,2831.101,1333.12,2831.101,1350.862z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2829.679,1360.343c-1.728,5.594-4.941,10.546-9.187,14.38 c-5.7,5.141-13.243,8.27-21.523,8.27c-17.741,0-32.132-14.391-32.132-32.132c0-1.075,0.052-2.128,0.158-3.171 c0.875-8.87,5.352-16.688,11.958-21.945C2778.225,1359.669,2806.143,1362.745,2829.679,1360.343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2820.492,1374.724c-5.7,5.141-13.243,8.27-21.523,8.27 c-17.741,0-32.132-14.391-32.132-32.132c0-1.075,0.052-2.128,0.158-3.171C2773,1370.131,2797.736,1377.463,2820.492,1374.724z"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    cx: 2348.564,
    cy: 1462.344,
    rx: 37.486,
    ry: 21.829
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2412.554,1275.638c0,0-0.175-3.438,1.712-4.829s2.591,1.605,2.591,1.605 c6.612-2.817,7.175-0.419,7.175-0.419c2.783,3.774,0.896,5.165,0.896,5.165c-1.676,2.291-9.768,4.19-9.768,4.19 L2412.554,1275.638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23477C"
    },
    d: "M2412.225,1273.696l-26.372,17.338c0,0-23.301-2.014-33.115,0.066l3.593,10.932l1.222,3.731 c0,0,29.904-0.485,33.332-3.138c3.232-2.519,23.936-19.309,26.242-21.202c0.021-0.03,0.044-0.047,0.069-0.05 c0.035-0.018,0.056-0.048,0.08-0.065c0.046-0.033,0.069-0.05,0.069-0.05L2412.225,1273.696z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15325C"
    },
    d: "M2371.967,1459.927c0.735-2.422-7.942-8.85-7.942-8.85l-10.921-1.67 c-2.724,4.862-2.602,6.596-0.557,7.915c14.379,7.211,17.536,5.525,17.536,5.525S2371.231,1462.349,2371.967,1459.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15325C"
    },
    d: "M2350.988,1471.247c0.735-2.422-7.942-8.85-7.942-8.85l-10.921-1.67 c-2.724,4.862-2.602,6.596-0.557,7.915c14.379,7.211,17.536,5.525,17.536,5.525S2350.253,1473.668,2350.988,1471.247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1249A"
    },
    d: "M2364.425,1355.389l1.784,45.617l-1.9,50.395c0,0-2.579,2.94-12.877,1.456l-2.165-43.41 l-11.879-66.659L2364.425,1355.389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1249A"
    },
    d: "M2349.383,1363.875l-5.91,98.535c0,0-2.575,2.943-12.875,1.472l-5.205-100.006H2349.383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15325C"
    },
    d: "M2323.111,1313.463v53.971c0,0,27.991,12.515,42.401-7.916l-1.201-61.213 c0,0-0.459-3.063-3.058-5.632c-1.313-1.298-2.982-2.074-4.728-2.304c-1.746-0.23-3.569,0.086-5.189,0.972l-22.349,12.214 c-1.467,0.801-2.708,1.901-3.668,3.2C2323.909,1308.665,2323.111,1311.006,2323.111,1313.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2365.285,1328.094c0,0-0.175-3.438,1.712-4.829s2.59,1.605,2.59,1.605 c6.612-2.817,7.175-0.419,7.175-0.419c2.783,3.774,0.896,5.165,0.896,5.165c-1.676,2.291-9.768,4.19-9.768,4.19 L2365.285,1328.094z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23477C"
    },
    d: "M2327.848,1305.422c8.079-0.432,8.4,12.481,8.4,12.481l1.661,19.189l26.644-10.608l3.859,7.188 c0,0-16.436,9.657-28.352,16.463c-5.88,3.358-13.317-0.016-14.661-6.652c-1.843-9.096-3.97-20.274-4.195-24.438 C2320.618,1308.194,2323.808,1305.645,2327.848,1305.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2349.631,1300.674c0,0-8.466,2.573-12.143-1.478v-21.443l1.704,1.721l9.335,9.422l0.843,9.014 L2349.631,1300.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2349.37,1297.91c-6.328-2.46-10.065-7.831-10.179-18.436l9.335,9.422L2349.37,1297.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2354.293,1267.193c0,0,9.994,26.629-1.33,27.072c-11.323,0.444-17.673-11.545-17.673-11.545 l4.815-11.625L2354.293,1267.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M2356.41,1262.766c-5.398-5.92-11.171,0-11.171,0c-12.684,0.697-25.799,15.568-7.749,26.851 v-2.783l1.856-2.42c3.911-0.835,2.264-7.717,2.264-7.717C2356.062,1277.567,2361.808,1268.686,2356.41,1262.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M2340.225,1282.26c1.612,1.549,1.993,3.768,0.85,4.957c-1.142,1.189-3.375,0.898-4.988-0.651 c-1.612-1.549-1.992-3.768-0.85-4.957C2336.38,1280.42,2338.613,1280.712,2340.225,1282.26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "2562.075,1573.465 2561.79,1573.631 2516.429,1599.822 2516.144,1599.656  2470.788,1573.465 2484.606,1565.371 2515.791,1547.113 2548.059,1565.485 2561.795,1573.304  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2516.429,1569.062 2516.144,1584.97 2515.952,1595.688 2470.788,1569.741  2470.788,1558.78 2484.606,1550.685  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23477C"
    },
    points: "2561.795,1558.619 2561.79,1558.945 2561.598,1569.741 2515.952,1595.688  2516.144,1584.97 2516.429,1569.062 2548.059,1550.799  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "2562.075,1558.78 2561.79,1558.945 2516.429,1585.136 2516.144,1584.97 2470.788,1558.78  2484.606,1550.685 2515.791,1532.428 2548.059,1550.799 2561.795,1558.619  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD561"
    },
    points: "2485.226,1558.734 2515.842,1540.81 2547.482,1558.824 2516.43,1576.754  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "2489.353,1558.722 2515.856,1543.205 2543.312,1558.837 2516.43,1574.358  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "2510.203,1558.768 2516.224,1555.243 2522.461,1558.794 2516.354,1562.32  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2515.856,1545.279 2541.503,1559.881 2543.312,1558.837 2515.856,1543.205  2489.353,1558.722 2491.136,1559.752  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2633.329,1417.255l5.844,3.537l5.042-2.885c0.95,0.307,1.967,0.552,3.033,0.728 v3.387h7.075v-3.269c1.362-0.176,2.651-0.465,3.838-0.848l5.313,3.04l5.844-3.537l-5.316-3.014 c1.012-1.147,1.583-2.448,1.583-3.826c0-1.42-0.607-2.757-1.677-3.929l5.102-2.919l-5.844-3.384l-5.068,2.874 c-1.057-0.337-2.194-0.599-3.391-0.775v-3.33h-7.075v3.335c-1.184,0.175-2.31,0.434-3.357,0.768l-4.795-2.719l-5.844,3.384 l4.827,2.762c-1.071,1.173-1.679,2.511-1.679,3.932c0,1.379,0.572,2.681,1.585,3.828L2633.329,1417.255z M2646.556,1410.568 c0-1.489,2.072-2.695,4.629-2.695c2.556,0,4.629,1.207,4.629,2.695c0,1.489-2.073,2.695-4.629,2.695 C2648.629,1413.263,2646.556,1412.056,2646.556,1410.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A302"
    },
    d: "M2633.329,1411.755l5.041-2.858c-1.013-1.148-1.585-2.449-1.585-3.829 c0-0.711,0.082-4.541,0.082-4.541s1.061,1.195,1.597,0.609l-4.827-2.762l5.844-3.384l4.795,2.719 c2.051-0.654,4.406-1.027,6.91-1.027c2.506,0,4.861,0.373,6.913,1.028l5.068-2.874l5.845,3.384l-5.102,2.919 c0.531,0.581,1.718-0.92,1.718-0.92s-0.042,4.133-0.042,4.849c0,1.378-0.571,2.679-1.583,3.826l5.316,3.014l-5.845,3.538 l-5.313-3.04c-2.067,0.668-4.445,1.048-6.976,1.048c-2.529,0-4.905-0.38-6.97-1.047l-5.042,2.885L2633.329,1411.755z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2647.171,
    y: 1411.755,
    style: {
      fill: "#FEC400"
    },
    width: 7.075,
    height: 4.614
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2639.173,1410.525 2639.173,1415.293 2633.329,1411.755 2633.329,1406.987  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2633.636,1393.606 2633.636,1398.374 2637.174,1400.374 2639.173,1396.067  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2663.474,1410.679 2663.474,1415.447 2669.319,1411.909 2669.319,1407.141  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2669.011,1393.453 2669.011,1398.221 2665.248,1400.374 2663.628,1396.375  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M2633.329,1406.987l5.844,3.537l5.042-2.885c0.95,0.307,1.967,0.552,3.033,0.728v3.387h7.075 v-3.269c1.362-0.176,2.651-0.464,3.838-0.848l5.313,3.04l5.844-3.537l-5.316-3.014c1.012-1.147,1.583-2.448,1.583-3.826 c0-1.42-0.607-2.757-1.677-3.929l5.102-2.919l-5.844-3.384l-5.068,2.874c-1.057-0.337-2.194-0.599-3.391-0.775v-3.33h-7.075 v3.335c-1.184,0.175-2.31,0.434-3.357,0.768l-4.795-2.719l-5.844,3.384l4.827,2.762c-1.071,1.173-1.679,2.511-1.679,3.932 c0,1.379,0.572,2.681,1.585,3.829L2633.329,1406.987z M2646.556,1400.301c0-1.489,2.072-2.695,4.629-2.695 c2.556,0,4.629,1.207,4.629,2.695c0,1.489-2.073,2.695-4.629,2.695C2648.629,1402.996,2646.556,1401.789,2646.556,1400.301z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2668.523,1415.357l9.713,5.879l8.378-4.794c1.579,0.51,3.269,0.917,5.041,1.21 v5.629h11.758v-5.433c2.263-0.293,4.406-0.772,6.378-1.409l8.831,5.052l9.713-5.879l-8.834-5.009 c1.682-1.906,2.631-4.068,2.631-6.359c0-2.36-1.009-4.582-2.786-6.53l8.478-4.851l-9.713-5.623l-8.423,4.776 c-1.756-0.561-3.647-0.996-5.635-1.287v-5.534h-11.758v5.542c-1.968,0.291-3.839,0.722-5.579,1.277l-7.968-4.518l-9.713,5.623 l8.022,4.59c-1.781,1.949-2.791,4.173-2.791,6.535c0,2.292,0.95,4.455,2.635,6.363L2668.523,1415.357z M2690.506,1404.245 c0-2.474,3.444-4.479,7.692-4.479c4.249,0,7.693,2.005,7.693,4.479s-3.444,4.479-7.693,4.479 C2693.95,1408.724,2690.506,1406.718,2690.506,1404.245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A302"
    },
    d: "M2668.523,1406.218l8.377-4.75c-1.684-1.907-2.635-4.07-2.635-6.363 c0-1.181,0.136-7.547,0.136-7.547s1.764,1.986,2.654,1.011l-8.022-4.59l9.713-5.623l7.968,4.518 c3.409-1.088,7.322-1.707,11.483-1.707c4.164,0,8.079,0.62,11.489,1.709l8.423-4.776l9.713,5.623l-8.478,4.851 c0.882,0.967,2.855-1.528,2.855-1.528s-0.069,6.869-0.069,8.058c0,2.291-0.949,4.452-2.631,6.359l8.835,5.009l-9.713,5.879 l-8.831-5.052c-3.435,1.11-7.386,1.742-11.593,1.742c-4.202,0-8.151-0.632-11.584-1.739l-8.379,4.794L2668.523,1406.218z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2691.528,
    y: 1406.218,
    style: {
      fill: "#FEC400"
    },
    width: 11.758,
    height: 7.668
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2678.236,1404.173 2678.236,1412.097 2668.523,1406.218 2668.523,1398.294  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2669.035,1376.057 2669.035,1383.98 2674.914,1387.303 2678.236,1380.146  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2718.622,1404.429 2718.622,1412.353 2728.335,1406.474 2728.335,1398.55  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2727.824,1375.801 2727.824,1383.725 2721.57,1387.303 2718.878,1380.657  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M2668.523,1398.294l9.713,5.879l8.378-4.794c1.579,0.51,3.269,0.917,5.041,1.21v5.629h11.758 v-5.433c2.263-0.293,4.406-0.772,6.378-1.409l8.831,5.052l9.713-5.879l-8.834-5.009c1.682-1.906,2.631-4.068,2.631-6.359 c0-2.36-1.009-4.582-2.786-6.53l8.478-4.851l-9.713-5.623l-8.423,4.776c-1.756-0.561-3.647-0.996-5.635-1.287v-5.534h-11.758 v5.542c-1.968,0.291-3.839,0.722-5.579,1.277l-7.968-4.518l-9.713,5.623l8.022,4.59c-1.781,1.949-2.791,4.173-2.791,6.535 c0,2.292,0.95,4.455,2.635,6.363L2668.523,1398.294z M2690.506,1387.182c0-2.474,3.444-4.479,7.692-4.479 c4.249,0,7.693,2.005,7.693,4.479c0,2.474-3.444,4.479-7.693,4.479C2693.95,1391.661,2690.506,1389.656,2690.506,1387.182z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2596.286,1355.546l8.377,5.07l7.226-4.135c1.362,0.44,2.819,0.791,4.347,1.043 v4.855h10.141v-4.686c1.952-0.253,3.8-0.666,5.501-1.215l7.616,4.358l8.377-5.07l-7.619-4.32c1.45-1.644,2.269-3.509,2.269-5.484 c0-2.035-0.87-3.952-2.403-5.632l7.312-4.184l-8.377-4.85l-7.264,4.119c-1.514-0.484-3.145-0.859-4.86-1.11v-4.772h-10.141v4.78 c-1.697,0.251-3.311,0.622-4.811,1.101l-6.872-3.897l-8.377,4.85l6.919,3.958c-1.536,1.681-2.407,3.599-2.407,5.636 c0,1.977,0.82,3.843,2.272,5.487L2596.286,1355.546z M2615.245,1345.962c0-2.134,2.97-3.863,6.634-3.863s6.634,1.73,6.634,3.863 c0,2.134-2.97,3.863-6.634,3.863S2615.245,1348.095,2615.245,1345.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A302"
    },
    d: "M2596.286,1349.278l7.225-4.096c-1.452-1.645-2.272-3.511-2.272-5.487 c0-1.019,0.118-6.509,0.118-6.509s1.521,1.713,2.289,0.872l-6.918-3.958l8.377-4.85l6.872,3.897 c2.94-0.938,6.314-1.472,9.903-1.472c3.591,0,6.968,0.534,9.909,1.474l7.264-4.119l8.377,4.85l-7.312,4.184 c0.76,0.833,2.462-1.318,2.462-1.318s-0.059,5.924-0.059,6.95c0,1.976-0.819,3.84-2.269,5.484l7.619,4.32l-8.377,5.07 l-7.616-4.357c-2.962,0.957-6.371,1.503-9.998,1.503c-3.624,0-7.03-0.545-9.99-1.5l-7.226,4.135L2596.286,1349.278z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2616.126,
    y: 1349.278,
    style: {
      fill: "#FEC400"
    },
    width: 10.141,
    height: 6.613
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2604.663,1347.515 2604.663,1354.349 2596.286,1349.278 2596.286,1342.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2596.727,1323.266 2596.727,1330.099 2601.797,1332.965 2604.663,1326.793  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2639.493,1347.735 2639.493,1354.569 2647.87,1349.499 2647.87,1342.665  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2647.429,1323.045 2647.429,1329.879 2642.035,1332.965 2639.714,1327.234  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M2596.286,1342.444l8.377,5.07l7.226-4.135c1.362,0.439,2.819,0.791,4.347,1.043v4.855h10.141 v-4.686c1.952-0.253,3.8-0.666,5.501-1.215l7.616,4.357l8.377-5.07l-7.619-4.32c1.45-1.644,2.269-3.509,2.269-5.484 c0-2.035-0.87-3.952-2.403-5.632l7.312-4.184l-8.377-4.85l-7.264,4.119c-1.514-0.484-3.145-0.859-4.86-1.11v-4.772h-10.141v4.779 c-1.697,0.251-3.311,0.623-4.811,1.101l-6.872-3.897l-8.377,4.85l6.919,3.958c-1.536,1.681-2.407,3.599-2.407,5.636 c0,1.977,0.82,3.842,2.272,5.488L2596.286,1342.444z M2615.245,1332.86c0-2.134,2.97-3.863,6.634-3.863s6.634,1.73,6.634,3.863 c0,2.134-2.97,3.863-6.634,3.863S2615.245,1334.994,2615.245,1332.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "2423.281,1285.264 2514.586,1337.438 2604.705,1285.264 2513.4,1230.718  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2426.158,1458.313l82.844,50.126c2.198,1.33,4.948,1.348,7.163,0.046l85.374-50.175 c2.29-1.346,3.441-3.673,3.45-6.004c0.008-2.331-1.126-4.666-3.406-6.028l-84.619-50.551c-2.221-1.327-4.994-1.319-7.207,0.021 l-83.599,50.6C2421.661,1449.069,2421.662,1455.593,2426.158,1458.313z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23477C"
    },
    points: "2513.4,1337.438 2513.4,1498.704 2604.705,1444.158 2604.705,1284.078  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M2524.072,1479.897v-136.335l69.961-40.885v135.425L2524.072,1479.897z M2526.444,1344.923 v130.793l65.218-38.96v-129.948L2526.444,1344.923z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "2423.281,1284.078 2423.281,1444.158 2513.4,1498.704 2513.4,1337.438  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23477C"
    },
    d: "M2432.917,1437.613v-129.307c0-1.794,0.861-3.287,2.125-4.217 c1.599-1.178,3.841-1.454,5.795-0.297l60.355,35.736c1.595,0.944,2.573,2.661,2.573,4.514v130.102 c0,4.087-4.467,6.605-7.963,4.488l-60.355-36.53C2433.876,1441.15,2432.917,1439.448,2432.917,1437.613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M2443.598,1438.544c-1.571-0.951-2.53-2.653-2.53-4.489v-129.307c0-0.24,0.018-0.474,0.048-0.703 l-0.429-0.254c-1.954-1.157-4.196-0.881-5.795,0.297c-1.263,0.93-2.125,2.424-2.125,4.217v129.307 c0,1.836,0.959,3.538,2.53,4.489l60.354,36.53c3.293,1.993,7.442-0.124,7.916-3.79L2443.598,1438.544z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "2503.914,1350.014 2444.625,1314.908 2444.625,1335.067 2503.914,1370.172  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "2503.914,1374.915 2444.625,1339.81 2444.625,1359.968 2503.914,1395.073  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "2503.914,1399.817 2444.625,1364.711 2444.625,1384.869 2503.914,1419.975  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "2503.914,1424.718 2444.625,1389.612 2444.625,1409.771 2503.914,1444.876  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "2503.914,1449.619 2444.625,1414.514 2444.625,1434.672 2503.914,1469.777  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "2454.802,1324.395 2454.802,1337.632 2493.737,1360.686 2493.737,1347.448  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "2454.802,1362.534 2493.737,1385.587 2493.737,1372.349 2454.802,1349.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "2454.802,1387.435 2493.737,1410.489 2493.737,1397.251 2454.802,1374.197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "2454.802,1412.336 2493.737,1435.39 2493.737,1422.152 2454.802,1399.099  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "2454.802,1437.238 2493.737,1460.291 2493.737,1447.053 2454.802,1424  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1929.044,1213.312 1929.044,1327.165 1926.923,1328.862 1862.874,1289.414  1860.753,1177.257 1862.874,1175.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1860.753,1177.257 1860.753,1291.111 1926.923,1328.862 1926.923,1215.008  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1860.753,1177.257 1860.753,1192.951 1926.923,1230.702 1926.923,1215.008  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1867.622,1209.23 1867.653,1214.451 1903.606,1235.28 1903.386,1229.914  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1885.614,1252.743 1885.645,1257.964 1921.598,1278.794 1921.378,1273.428  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1907.739,1232.5 1907.739,1237.56 1921.252,1245.396 1921.252,1240.338  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1873.434,1235.132 1873.434,1240.193 1886.948,1248.029 1886.948,1242.97  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1869.06,1244.177 1869.06,1249.238 1882.574,1257.074 1882.574,1252.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1889.841,1232.5 1921.221,1250.617 1921.221,1255.856 1889.783,1237.56  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1889.841,1243.519 1921.221,1261.636 1921.221,1266.875 1889.783,1248.579  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1867.622,1254.848 1867.653,1260.069 1903.606,1280.899 1903.386,1275.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1885.614,1289.238 1885.645,1294.459 1921.598,1315.288 1921.378,1309.922  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1907.739,1278.118 1907.739,1283.179 1921.252,1291.015 1921.252,1285.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1873.434,1271.627 1873.434,1276.688 1886.948,1284.524 1886.948,1279.465  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1869.06,1280.672 1869.06,1285.733 1882.574,1293.569 1882.574,1288.51  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1889.841,1280.013 1921.221,1298.131 1921.221,1303.369 1889.783,1285.074  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "2047.77,1307.2 2047.77,1361.323 2044.504,1363.189 1956.32,1307.2 1953.054,1255.876  1956.32,1254.009  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2044.504,1309.066 2044.504,1363.189 1953.054,1309.066 1953.054,1255.876  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2019.425,1307.613 2016.718,1306.028 2016.718,1301.261 2019.425,1302.846  2025.249,1306.256 2036.006,1312.554 2036.006,1317.32 2025.249,1311.022  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2020.018,1319.693 2020.018,1314.926 2025.249,1317.989 2036.006,1324.286  2036.006,1329.053 2025.249,1322.755  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "2025.249,1337.054 2036.006,1343.352 2036.006,1348.119 2025.249,1341.821  2019.425,1338.411 2011.219,1333.607 2011.219,1328.84 2019.425,1333.645  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2003.519,1314.798 2010.238,1318.733 2019.425,1324.112 2024.785,1327.25  2024.785,1332.017 2019.425,1328.878 2010.238,1323.5 2003.519,1319.565  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2026.251,1328.109 2036.006,1333.82 2036.006,1338.586 2026.251,1332.875  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2018.551,1318.834 2010.238,1313.967 1999.183,1307.493 1993.84,1304.365  1993.84,1299.598 1999.183,1302.726 2010.238,1309.2 2018.551,1314.067  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1987.274,1295.755 1992.202,1298.639 1992.202,1303.405 1987.274,1300.522  1960.671,1285.407 1960.671,1280.641  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2002.052,1313.939 2002.052,1318.706 1999.183,1317.026 1992.3,1312.996  1987.274,1310.055 1978.273,1304.941 1978.273,1300.174 1987.274,1305.288 1992.3,1308.229 1999.183,1312.26  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1976.634,1304.01 1960.671,1294.941 1960.671,1290.174 1976.634,1299.243  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1983.189,1317.266 1960.671,1304.473 1960.671,1299.707 1983.189,1312.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1992.3,1317.762 1999.183,1321.792 2009.752,1327.982 2009.752,1332.748  1999.183,1326.559 1992.3,1322.528 1987.274,1319.588 1984.828,1318.198 1984.828,1313.431 1987.274,1314.821  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22,
      fill: "#15325C"
    },
    d: "M1605.06,1540.465l6.601,3.805l297.949,171.841c2.231,1.283,4.737,1.88,7.228,1.772 c2.139-0.076,4.233-0.672,6.143-1.772l218.003-126.062l3.407-1.971l6.616-3.82c4.447-2.567,6.677-7.075,6.677-11.567 c0-0.152,0-0.321-0.015-0.474c-0.137-4.339-2.368-8.618-6.677-11.094l-26.557-15.296l-277.841-160.076 c-4.126-2.368-9.214-2.368-13.34,0l-228.195,131.563C1596.152,1522.465,1596.152,1535.331,1605.06,1540.465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M1596.214,1467.429c-0.032-0.544-0.032-1.086,0-1.63v-28.786l17.06,12.01l217.767-125.552 c4.125-2.384,9.214-2.384,13.34,0l255.944,147.454l35.756,20.598l6.096,3.515l6.602,3.805c4.568,2.628,6.799,7.273,6.677,11.873 c-0.092,4.385-2.323,8.756-6.663,11.261l-228.027,131.853c-1.925,1.1-4.034,1.696-6.173,1.773 c-2.475,0.107-4.966-0.489-7.197-1.773l-304.55-175.646c-4.077-2.349-6.265-6.32-6.611-10.427l-0.02,0.014V1467.429z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M1914.593,1624.858v30.744c2.139-0.076,4.248-0.672,6.173-1.773l228.027-131.853 c4.34-2.506,6.57-6.876,6.662-11.261l0.473,0.382l-0.458-31.447v-0.489l-0.015,0.015c-0.138-4.339-2.369-8.618-6.678-11.094 l-26.557-15.296l-21.897,18.138l-185.701,153.918L1914.593,1624.858z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1748.417,1511.163 1748.496,1562.35 1722.763,1547.324 1723.013,1501.014  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1758.439,1524.896 1758.439,1567.92 1765.693,1572.104 1765.693,1531.682  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1602.845,1447.424l6.601,3.805l297.949,171.841c2.231,1.283,4.737,1.88,7.228,1.772 c2.139-0.076,4.233-0.672,6.143-1.772l218.003-126.062l3.407-1.971l6.616-3.82c4.447-2.567,6.678-7.075,6.678-11.567 c0-0.152,0-0.321-0.015-0.474c-0.138-4.339-2.369-8.618-6.678-11.094l-26.557-15.296l-277.841-160.076 c-4.126-2.368-9.214-2.368-13.34,0l-228.195,131.563C1593.937,1429.424,1593.937,1442.29,1602.845,1447.424z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -396.4294 1677.0568)",
    style: {
      fill: "#D6EFFB"
    },
    cx: 1826.172,
    cy: 1317.061,
    rx: 7.714,
    ry: 7.714
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D1EA"
    },
    d: "M1824.112,1167.438l-6.122,147.987l-154.285,100.285l-6.121-3.296 c-1.547-0.833-2.802-2.056-3.671-3.511c-0.869-1.455-1.351-3.14-1.351-4.897v-142.628c0-1.313,0.348-2.576,0.979-3.677 s1.546-2.04,2.678-2.703l153.107-89.643c1.563-0.915,3.31-1.383,5.061-1.403c1.752-0.02,3.508,0.409,5.091,1.289 L1824.112,1167.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EFFB"
    },
    d: "M1825.734,1171.339v148.953l-165.427,94.285v-148.351c0-1.291,0.338-2.534,0.952-3.621 c0.629-1.113,1.548-2.063,2.689-2.731l156.445-91.597c1.183-0.693,2.518-0.612,3.557-0.016 C1824.99,1168.857,1825.734,1169.969,1825.734,1171.339z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1822.305,1183.956 1822.305,1308.327 1802.725,1319.484 1796.845,1322.839  1756.645,1345.751 1734.376,1358.44 1699.413,1378.37 1665.449,1397.728 1665.449,1275.795 1698.694,1256.332 1716.69,1245.793  1745.084,1229.171 1779.247,1209.164 1800.522,1196.709 1816.051,1187.62  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M1665.736,1451.532l117.826,68.48c2.27,1.319,5.072,1.32,7.342,0.001l161.13-93.559 c2.399-1.393,3.612-3.811,3.638-6.24c0.026-2.473-1.177-4.957-3.612-6.385l-52.438-30.74c-1.592-0.933-3.477-1.23-5.278-0.83 l-210.015,46.585c-0.695,0.154-1.365,0.409-1.986,0.757l-16.502,9.234C1660.9,1441.6,1660.842,1448.688,1665.736,1451.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D1EA"
    },
    d: "M1665.318,1431.169l122.651,70.425c1.317,0.756,2.758,1.201,4.22,1.334 c2.108,0.193,4.261-0.26,6.153-1.358l151.06-87.662c1.116-0.648,2.019-1.565,2.646-2.641c0.677-1.161,1.033-2.508,0.991-3.901 l-0.21-6.979l-128.809-68.954l-163.713,83.142v7.935c0,1.644,0.404,3.231,1.143,4.638 C1662.316,1428.802,1663.644,1430.208,1665.318,1431.169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EFFB"
    },
    d: "M1660.306,1414.577l127.261,77.998c1.469,0.901,3.099,1.427,4.756,1.577 c2.23,0.202,4.51-0.277,6.516-1.441l151.502-87.918c1.57-0.911,2.489-2.391,2.752-3.965c0.36-2.16-0.515-4.499-2.639-5.797 l-126.433-77.309L1660.306,1414.577z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1676.308,1414.597 1825.875,1326.109 1925.959,1387.306 1776.39,1475.794  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.9871 -0.1602 0.1602 0.9871 -204.976 284.3727)",
    style: {
      fill: "#A9D1EA"
    },
    cx: 1661.363,
    cy: 1413.571,
    rx: 7.714,
    ry: 7.714
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.71
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1754.322,1397.8 1774.634,1385.782 1789.894,1394.811 1769.582,1406.828  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1813.098,1381.082 1792.786,1393.099 1777.526,1384.071 1797.838,1372.054  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1751.429,1396.088 1736.835,1387.454 1757.147,1375.437 1771.741,1384.071  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1728.224,1409.817 1713.631,1401.182 1733.943,1389.166 1748.537,1397.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1872.608,1388.833 1852.297,1400.85 1837.036,1391.822 1857.348,1379.805  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1831.251,1391.822 1810.939,1403.839 1795.679,1394.811 1815.991,1382.794  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1854.456,1378.094 1834.144,1390.11 1818.883,1381.082 1839.196,1369.065  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1704.781,1423.686 1690.445,1414.9 1710.738,1402.894 1725.332,1411.528  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1860.241,1378.094 1879.972,1366.42 1894.98,1375.597 1875.501,1387.122  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1897.825,1377.337 1912.297,1386.186 1893.108,1397.539 1878.394,1388.833  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1842.088,1367.354 1862.118,1355.504 1877.127,1364.681 1857.348,1376.382  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1813.832,1405.55 1834.144,1393.533 1849.404,1402.562 1829.092,1414.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1774.634,1382.36 1760.04,1373.726 1780.352,1361.709 1794.946,1370.343  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1797.838,1368.631 1783.244,1359.998 1803.557,1347.98 1818.15,1356.614  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1823.936,1356.614 1844.265,1344.587 1859.273,1353.764 1839.196,1365.643  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1746.377,1423.979 1761.637,1433.007 1740.446,1445.545 1725.455,1436.357  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1743.287,1447.286 1764.53,1434.718 1779.79,1443.747 1758.277,1456.474  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1767.423,1433.007 1787.734,1420.99 1802.995,1430.018 1782.683,1442.035  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1821.043,1354.903 1806.449,1346.269 1827.067,1334.071 1841.42,1342.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1782.683,1445.458 1797.397,1454.163 1775.574,1467.075 1761.119,1458.216  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1785.575,1443.747 1805.887,1431.729 1820.602,1440.435 1800.29,1452.452  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1728.224,1413.239 1743.484,1422.267 1722.613,1434.615 1707.623,1425.428  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1772.474,1408.539 1792.786,1396.522 1808.047,1405.55 1787.734,1417.567  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1731.117,1411.528 1751.429,1399.511 1766.689,1408.539 1746.377,1420.556  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1749.27,1422.267 1769.582,1410.25 1784.842,1419.279 1764.53,1431.296  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1790.627,1419.279 1810.939,1407.262 1826.199,1416.29 1827.157,1415.724  1805.887,1428.307  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1836.303,1367.354 1815.991,1379.371 1800.731,1370.343 1821.043,1358.326  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1855.189,1402.562 1875.501,1390.544 1890.216,1399.25 1869.904,1411.267  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1808.78,1430.018 1852.297,1404.273 1867.011,1412.978 1823.495,1438.724  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1752.338,1271.788 1748.595,1273.979 1740.542,1278.695 1725.664,1287.405  1725.664,1293.997 1740.542,1285.287 1748.595,1280.571 1752.338,1278.38  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1711.773,1262.661 1708.029,1264.852 1699.976,1269.568 1685.099,1278.278  1685.099,1284.87 1699.976,1276.16 1708.029,1271.444 1711.773,1269.252  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1711.773,1273.816 1708.029,1276.008 1699.976,1280.724 1685.099,1289.433  1685.099,1296.025 1699.976,1287.315 1708.029,1282.6 1711.773,1280.408  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F02098"
    },
    points: "1793.059,1264.173 1786.109,1268.24 1776.589,1273.814 1761.301,1282.767  1749.803,1289.498 1749.803,1296.09 1761.301,1289.359 1776.589,1280.406 1786.109,1274.832 1793.059,1270.765  1795.858,1269.125 1795.858,1262.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1747.775,1290.686 1740.542,1294.922 1725.664,1303.631 1725.664,1310.223  1740.542,1301.513 1747.775,1297.278  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1759.944,1309.929 1748.595,1316.573 1740.542,1321.289 1725.664,1329.999  1725.664,1336.591 1740.542,1327.881 1748.595,1323.165 1759.944,1316.521  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1793.059,1290.541 1786.109,1294.608 1776.589,1300.182 1761.973,1308.741  1761.973,1315.333 1776.589,1306.774 1786.109,1301.2 1793.059,1297.133 1795.858,1295.493 1795.858,1288.901  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1770.593,1290.509 1761.301,1295.951 1748.595,1303.39 1741.183,1307.73  1741.183,1314.322 1748.595,1309.981 1761.301,1302.543 1770.593,1297.101  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1739.155,1308.917 1725.664,1316.815 1725.664,1323.407 1739.155,1315.509  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1793.059,1277.357 1786.109,1281.424 1776.589,1286.998 1772.621,1289.321  1772.621,1295.913 1776.589,1293.59 1786.109,1288.016 1793.059,1283.949 1795.858,1282.309 1795.858,1275.717  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1642.697,1327.507 1642.697,1401.91 1644.799,1403.592 1708.273,1364.498  1710.375,1291.776 1708.273,1290.095  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1710.375,1291.776 1710.375,1366.18 1644.799,1403.592 1644.799,1329.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1710.375,1291.776 1710.375,1307.329 1644.799,1344.741 1644.799,1329.188  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1705.828,1321.201 1705.797,1326.375 1670.167,1347.018 1670.385,1341.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "1687.998,1364.324 1687.967,1369.498 1652.337,1390.14 1652.555,1384.822  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1666.072,1344.262 1666.072,1349.277 1652.68,1357.042 1652.68,1352.03  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1700.068,1346.871 1700.068,1351.886 1686.676,1359.651 1686.676,1354.639  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1704.403,1355.835 1704.403,1360.85 1691.011,1368.615 1691.011,1363.603  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1683.809,1344.262 1652.711,1362.216 1652.711,1367.408 1683.866,1349.277  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1683.809,1355.182 1652.711,1373.136 1652.711,1378.328 1683.866,1360.197  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M1991.887,1348.682c2.984-0.299,5.601,1.211,6.404,9.231c0.803,8.019,0.554,21.966,0.554,21.966 l-5.435,25.097l-5.995-0.803l2.547-25.43l-2.82-19.967C1987.143,1358.775,1985.918,1349.279,1991.887,1348.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M1978.505,1471.873c0.545-1.909,8.997-2.454,8.997-2.454l7.907,3.544 c-0.273,4.362-1.091,5.453-2.999,5.453c-12.542-1.363-13.905-3.817-13.905-3.817S1977.96,1473.782,1978.505,1471.873z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15325C"
    },
    d: "M1977.687,1405.893l4.908,36.262l4.09,29.446c0,0,1.908,2.181,9.543,1.091l-1.905-32.99 l0.889-39.537L1977.687,1405.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M1959.965,1480.871c0.545-1.909,8.997-2.454,8.997-2.454l7.907,3.544 c-0.273,4.362-1.091,5.453-2.999,5.453c-12.542-1.363-13.905-3.817-13.905-3.817S1959.42,1482.779,1959.965,1480.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#15325C"
    },
    d: "M1967.599,1410.255l-1.363,33.808l1.363,37.353c0,0,1.909,2.181,9.543,1.091l1.643-32.172 l8.864-49.395L1967.599,1410.255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC400"
    },
    d: "M1966.372,1363.552v49.293c0,0,22.902,6.271,30.536-11.451l-1.091-15.813l1.091-33.263 c0,0-0.34-2.27-2.267-4.174c-0.974-0.962-2.211-1.537-3.505-1.708c-1.294-0.17-2.645,0.064-3.846,0.72l-16.564,9.052 c-1.087,0.594-2.007,1.409-2.718,2.372C1966.964,1359.996,1966.372,1361.731,1966.372,1363.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M1969.917,1329.423c0,0-1.908,20.994,6.271,19.085c8.179-1.908,10.361-11.724,10.361-11.724 l-5.726-7.361H1969.917z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CAAB"
    },
    d: "M1978.232,1343.73l-0.818,8.725c0,0,6.271,1.908,8.997-1.091v-7.634H1978.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M1974.824,1337.33c-3.544-0.818-2.181-4.09-2.181-4.09s-4.635-1.909-4.635-5.726 s3.544-6.271,3.544-6.271l1.909,1.363c0,0,10.633-0.818,13.905,5.453c3.272,6.271-1.091,17.449-1.091,17.449h-4.623l-4.101-6.543 L1974.824,1337.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M1972.962,1338.6c0,1.702,1.38,3.081,3.081,3.081c1.702,0,3.081-1.379,3.081-3.081 c0-1.702-1.379-3.081-3.081-3.081C1974.342,1335.519,1972.962,1336.899,1972.962,1338.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M1938.869,1351.439c-0.434-3.163,2.357-2.605,3.66,3.846l-3.412,1.923 C1926.277,1357.27,1929.006,1350.446,1938.869,1351.439z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M1976.719,1356.335c-5.243-3.834-11.121,4.709-11.121,4.709l-9.532,12.174l-13.263-18.818 l-5.747,3.141c0,0,6.816,13.701,11.844,23.504c2.481,4.837,8.961,5.829,12.776,1.957c5.228-5.308,11.561-11.891,13.538-14.592 C1980.365,1361.37,1979.338,1358.257,1976.719,1356.335z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    cx: 1971.397,
    cy: 1481.162,
    rx: 27.58,
    ry: 16.061
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1935.939,1495.577 1986.647,1525.12 1901.105,1574.946 1850.838,1544.962  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1959.75,
    y: 1463.669,
    transform: "matrix(0.5003 -0.8659 0.8659 0.5003 -311.2988 2443.4468)",
    style: {
      fill: "#77B8E0"
    },
    width: 3.086,
    height: 55.513
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1984.883,1526.921c0.974,0,1.764-0.79,1.764-1.764v-55.999c0-0.974-0.79-1.764-1.764-1.764 c-0.974,0-1.764,0.79-1.764,1.764v55.999C1983.119,1526.131,1983.909,1526.921,1984.883,1526.921z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1987.161,1513.692v11.391c0,1.258-1.02,2.278-2.278,2.278c-1.258,0-2.278-1.02-2.278-2.278 v-11.391H1987.161z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1852.602,1546.763c0.974,0,1.764-0.79,1.764-1.764V1489c0-0.974-0.79-1.764-1.764-1.764 c-0.974,0-1.764,0.79-1.764,1.764v55.999C1850.838,1545.973,1851.628,1546.763,1852.602,1546.763z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1854.88,1533.535v11.391c0,1.258-1.02,2.278-2.278,2.278c-1.258,0-2.278-1.02-2.278-2.278 v-11.391H1854.88z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1901.105,1575.424c0.974,0,1.764-0.79,1.764-1.764v-55.999c0-0.974-0.79-1.764-1.764-1.764 s-1.764,0.79-1.764,1.764v55.999C1899.341,1574.634,1900.131,1575.424,1901.105,1575.424z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1935.939,1442.26 1986.647,1466.953 1986.647,1471.803 1901.105,1521.629  1850.838,1491.646 1850.838,1486.795  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1935.939,1437.41 1986.647,1466.953 1901.105,1516.779 1850.838,1486.795  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1903.383,1562.196v11.391c0,1.258-1.02,2.278-2.278,2.278c-1.258,0-2.278-1.02-2.278-2.278 v-11.391H1903.383z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1875.09,
    y: 1513.936,
    transform: "matrix(0.5003 -0.8659 0.8659 0.5003 -397.1268 2395.2622)",
    style: {
      fill: "#77B8E0"
    },
    width: 3.086,
    height: 55.513
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1990.606,1568.936 1963.528,1584.778 1935.764,1567.487 1963.109,1552.572  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1962.646,1585.66c-0.487,0-0.882-0.395-0.882-0.882v-31.333c0-0.487,0.395-0.882,0.882-0.882 c0.487,0,0.882,0.395,0.882,0.882v31.333C1963.528,1585.265,1963.133,1585.66,1962.646,1585.66z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1961.507,1579.711v5.696c0,0.629,0.51,1.139,1.139,1.139c0.629,0,1.139-0.51,1.139-1.139v-5.696 H1961.507z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1991.488,1569.818c-0.487,0-0.882-0.395-0.882-0.882v-31.333c0-0.487,0.395-0.882,0.882-0.882 s0.882,0.395,0.882,0.882v31.333C1992.37,1569.423,1991.975,1569.818,1991.488,1569.818z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1990.349,1563.869v5.696c0,0.629,0.51,1.139,1.139,1.139s1.139-0.51,1.139-1.139v-5.696H1990.349 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1935.713,1570.151c-0.487,0-0.882-0.395-0.882-0.882v-31.333c0-0.487,0.395-0.882,0.882-0.882 s0.882,0.395,0.882,0.882v31.333C1936.595,1569.756,1936.2,1570.151,1935.713,1570.151z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A9D1EA"
    },
    d: "M1964.306,1554.028L1964.306,1554.028c-0.119,0.653-0.545,1.148-1.084,1.395 c-0.539,0.247-1.192,0.246-1.764-0.09l-26.765-15.744v-2.692L1964.306,1554.028z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1969.949,1525.028 1962.226,1521.112 1934.816,1537.019 1962.226,1553.172  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C427E"
    },
    d: "M1934.574,1564.202v5.696c0,0.629,0.51,1.139,1.139,1.139c0.629,0,1.139-0.51,1.139-1.139v-5.696 H1934.574z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1961.981,1552.927 1971.281,1514.749 1999.915,1496.639 2002.239,1498.229  1990.37,1536.53 1964.306,1554.273  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1964.428,1554.395 1973.728,1516.217 2002.362,1498.107 1992.817,1537.998  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M1930.407,1488.063c0,1.219-0.988,2.207-2.207,2.207s-2.207-0.988-2.207-2.207 s0.988-2.207,2.207-2.207S1930.407,1486.845,1930.407,1488.063z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#052754"
    },
    points: "1919.202,1463.787 1901.886,1473.973 1883.891,1481.782 1883.891,1484.498  1910.375,1499.438 1928.03,1489.252 1945.686,1479.066 1945.686,1476.35  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1929.146,1487.368 1942.851,1470.726 1943.83,1476.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1942.851,1470.726 1940.319,1473.804 1929.238,1487.257 1929.146,1487.368  1903.958,1472.753 1903.984,1472.727 1904.222,1472.502 1920.009,1457.348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1929.146,1487.368 1928.432,1487.46 1911.199,1489.653 1891.268,1478.581  1884.768,1474.969 1903.544,1472.779 1903.984,1472.727 1904.01,1472.724 1904.346,1472.684  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1929.238,1487.257 1929.146,1487.368 1928.432,1487.46 1903.73,1472.89  1903.544,1472.779 1903.984,1472.727 1904.222,1472.502 1904.304,1472.551  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1884.768,1474.969 1884.768,1481.402 1911.199,1496.179 1911.199,1489.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1911.199,1489.653 1911.199,1496.179 1929.146,1487.368  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M2034.445,1476.445l45.819-26.828c1.276-0.747,2.854-0.757,4.139-0.025 l47.205,26.878c2.778,1.582,2.791,5.583,0.021,7.181l-46.469,26.829c-1.281,0.739-2.858,0.739-4.139,0l-46.556-26.879 C2031.718,1482.013,2031.705,1478.049,2034.445,1476.445z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "2119.873,1459.026 2083.473,1480.042 2083.092,1501.277 2119.491,1480.585  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "2047.074,1459.026 2082.965,1438.011 2119.873,1459.026 2083.473,1480.042  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15325C"
    },
    points: "2062.832,1459.026 2082.809,1447.329 2103.352,1459.026 2083.092,1470.724  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "2047.074,1480.585 2047.074,1459.026 2083.473,1480.042 2083.092,1501.277  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 2077.113,
    y: 1427.123,
    style: {
      fill: "#15325C"
    },
    width: 10.021,
    height: 30.564
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#15325C"
    },
    points: "2082.124,1442.155 2099.661,1423.616 2101.665,1427.123 2083.126,1447.165  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2118.7,1421.361c0,1.568-0.235,3.081-0.676,4.51c-1.924,6.238-7.736,10.773-14.606,10.773 c-8.438,0-15.282-6.844-15.282-15.282c0-4.835,2.25-9.149,5.762-11.945c2.61-2.089,5.917-3.337,9.52-3.337 C2111.856,1406.079,2118.7,1412.923,2118.7,1421.361z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2118.024,1425.87c-0.822,2.661-2.35,5.016-4.369,6.839 c-2.711,2.445-6.298,3.933-10.237,3.933c-8.438,0-15.282-6.844-15.282-15.282c0-0.511,0.025-1.012,0.075-1.508 c0.416-4.219,2.545-7.937,5.687-10.437C2093.553,1425.55,2106.831,1427.013,2118.024,1425.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2113.655,1432.71c-2.711,2.445-6.298,3.933-10.237,3.933 c-8.438,0-15.282-6.844-15.282-15.282c0-0.511,0.025-1.012,0.075-1.508C2091.068,1430.525,2102.832,1434.013,2113.655,1432.71z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M2106.675,1406.329c0,2.494-0.374,4.9-1.076,7.171c-3.059,9.92-12.302,17.13-23.225,17.13 c-13.417,0-24.301-10.884-24.301-24.301c0-7.689,3.578-14.549,9.163-18.995c4.151-3.322,9.41-5.306,15.138-5.306 C2095.792,1382.028,2106.675,1392.912,2106.675,1406.329z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2105.6,1413.5c-1.307,4.231-3.737,7.975-6.948,10.876 c-4.311,3.888-10.015,6.255-16.278,6.255c-13.417,0-24.301-10.884-24.301-24.301c0-0.813,0.04-1.609,0.119-2.398 c0.661-6.708,4.048-12.621,9.043-16.596C2066.686,1412.99,2087.8,1415.317,2105.6,1413.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M2098.652,1424.376c-4.311,3.888-10.015,6.255-16.278,6.255 c-13.417,0-24.301-10.884-24.301-24.301c0-0.813,0.04-1.609,0.119-2.398C2062.734,1420.902,2081.442,1426.448,2098.652,1424.376 z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M1563.002,1549.801v20.253l0.107-0.078c0.301,1.788,1.341,3.47,3.129,4.5l68.057,39.291 c1.011,0.583,2.138,0.875,3.265,0.865c1.108-0.01,2.216-0.292,3.207-0.865l68.135-39.447c2.157-1.244,3.217-3.431,3.217-5.607 v-18.912l-14.286,6.949l-56.959-32.799c-2.002-1.147-4.461-1.147-6.463,0.01l-44.004,25.374l-11.419,6.579L1563.002,1549.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M1563.002,1549.801v20.253l0.107-0.078c0.301,1.788,1.341,3.47,3.129,4.5l68.057,39.291 c1.011,0.583,2.138,0.875,3.265,0.865v-24.383l-47.153-40.914l-11.419,6.579L1563.002,1549.801z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1640.878,1504.894l68.008,39.155c4.318,2.486,4.326,8.715,0.013,11.211l-68.128,39.444 c-2.004,1.16-4.474,1.161-6.479,0.004l-68.056-39.292c-4.317-2.492-4.315-8.723,0.003-11.213l68.176-39.306 C1636.415,1503.743,1638.878,1503.742,1640.878,1504.894z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1640.878,1504.285l68.008,39.155c4.318,2.486,4.326,8.715,0.013,11.211l-68.128,39.444 c-2.004,1.16-4.474,1.161-6.479,0.004l-68.056-39.292c-4.317-2.492-4.315-8.724,0.003-11.213l68.176-39.307 C1636.415,1503.134,1638.878,1503.133,1640.878,1504.285z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M1590.283,1550.656l45.819-26.828c1.276-0.747,2.854-0.757,4.139-0.025 l47.205,26.878c2.778,1.582,2.79,5.583,0.021,7.181L1641,1584.691c-1.281,0.74-2.858,0.74-4.139,0l-46.555-26.879 C1587.556,1556.225,1587.544,1552.26,1590.283,1550.656z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A9D1EA"
    },
    points: "1675.711,1533.238 1639.312,1554.253 1638.93,1575.488 1675.329,1554.797  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1602.912,1533.238 1638.803,1512.223 1675.711,1533.238 1639.312,1554.253  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#15325C"
    },
    points: "1618.67,1533.238 1638.647,1521.541 1659.19,1533.238 1638.93,1544.935  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#77B8E0"
    },
    points: "1602.912,1554.797 1602.912,1533.238 1639.312,1554.253 1638.93,1575.488  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 1632.951,
    y: 1501.335,
    style: {
      fill: "#15325C"
    },
    width: 10.021,
    height: 30.564
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#15325C"
    },
    points: "1637.962,1516.366 1655.499,1497.827 1657.503,1501.335 1638.964,1521.377  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1674.539,1495.573c0,1.568-0.235,3.081-0.677,4.509c-1.924,6.238-7.736,10.773-14.606,10.773 c-8.438,0-15.282-6.844-15.282-15.282c0-4.835,2.25-9.149,5.762-11.945c2.61-2.089,5.917-3.337,9.52-3.337 C1667.694,1480.291,1674.539,1487.135,1674.539,1495.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M1673.862,1500.082c-0.822,2.661-2.35,5.016-4.369,6.839 c-2.711,2.445-6.298,3.933-10.237,3.933c-8.438,0-15.282-6.844-15.282-15.282c0-0.511,0.025-1.012,0.075-1.508 c0.416-4.219,2.545-7.937,5.687-10.437C1649.391,1499.761,1662.669,1501.224,1673.862,1500.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M1669.493,1506.921c-2.711,2.445-6.298,3.933-10.237,3.933 c-8.438,0-15.282-6.844-15.282-15.282c0-0.511,0.025-1.012,0.075-1.508C1646.906,1504.737,1658.67,1508.224,1669.493,1506.921z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#77B8E0"
    },
    d: "M1662.514,1480.541c0,2.494-0.374,4.9-1.076,7.171c-3.059,9.92-12.302,17.13-23.225,17.13 c-13.417,0-24.301-10.884-24.301-24.301c0-7.689,3.578-14.549,9.163-18.995c4.151-3.322,9.41-5.306,15.138-5.306 C1651.63,1456.24,1662.514,1467.124,1662.514,1480.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M1661.438,1487.712c-1.307,4.231-3.737,7.975-6.947,10.876 c-4.311,3.888-10.016,6.255-16.278,6.255c-13.417,0-24.301-10.884-24.301-24.301c0-0.813,0.04-1.609,0.119-2.398 c0.661-6.709,4.048-12.621,9.043-16.597C1622.524,1487.202,1643.638,1489.528,1661.438,1487.712z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#77B8E0"
    },
    d: "M1654.49,1498.587c-4.311,3.888-10.016,6.255-16.278,6.255 c-13.417,0-24.301-10.884-24.301-24.301c0-0.813,0.04-1.609,0.119-2.398C1618.573,1495.114,1637.28,1500.659,1654.49,1498.587z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M1730.785,1663.075l0.254-0.17c0.127,0.198,0.297,0.382,0.523,0.516l79.557,45.926 c0.219,0.127,0.459,0.198,0.7,0.205c0.297,0.014,0.601-0.056,0.862-0.212l20.239-11.929c0.572-0.339,0.806-0.947,0.735-1.526 l0.021-0.007v-13.589l-10.296,6.947l-11.561-6.678l-58.258-33.63c-0.474-0.275-1.067-0.275-1.548,0l-7.265,4.198l-13.921-4.402 L1730.785,1663.075z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M1811.819,1682.558v26.995c0.297,0.014,0.601-0.056,0.862-0.212l20.239-11.929 c0.572-0.339,0.806-0.947,0.735-1.526l0.021-0.007v-13.589l-10.296,6.947L1811.819,1682.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1832.916,1683.735l-20.234,11.93c-0.481,0.284-1.078,0.286-1.561,0.007l-79.555-45.931 c-1.033-0.596-1.033-2.087,0-2.683l20.449-11.806c0.479-0.277,1.07-0.277,1.549,0l79.341,45.807 C1833.931,1681.652,1833.938,1683.133,1832.916,1683.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1832.916,1683.325l-20.234,11.93c-0.481,0.284-1.078,0.286-1.561,0.007l-79.555-45.931 c-1.033-0.596-1.033-2.087,0-2.683l20.449-11.806c0.479-0.277,1.07-0.277,1.549,0l79.341,45.807 C1833.931,1681.242,1833.938,1682.723,1832.916,1683.325z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M1762.122,1629.999l0.254-0.17c0.127,0.198,0.297,0.382,0.523,0.516l79.557,45.926 c0.219,0.127,0.459,0.198,0.7,0.205c0.297,0.014,0.601-0.057,0.862-0.212l20.239-11.928c0.572-0.339,0.806-0.947,0.735-1.526 l0.021-0.007v-13.589l-10.296,6.947l-11.561-6.678l-58.258-33.63c-0.474-0.276-1.067-0.276-1.548,0l-7.265,4.198l-13.921-4.403 L1762.122,1629.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M1843.155,1649.482v26.995c0.297,0.014,0.601-0.057,0.862-0.212l20.239-11.928 c0.572-0.339,0.806-0.947,0.735-1.526l0.021-0.007v-13.589l-10.296,6.947L1843.155,1649.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1864.253,1650.66l-20.234,11.93c-0.481,0.284-1.078,0.286-1.561,0.007l-79.555-45.931 c-1.033-0.596-1.033-2.087,0-2.683l20.449-11.806c0.479-0.277,1.07-0.277,1.549,0l79.341,45.807 C1865.268,1648.577,1865.275,1650.057,1864.253,1650.66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1864.253,1650.25l-20.234,11.93c-0.481,0.284-1.078,0.286-1.561,0.007l-79.555-45.931 c-1.033-0.596-1.033-2.087,0-2.683l20.449-11.806c0.479-0.277,1.07-0.277,1.549,0l79.341,45.807 C1865.268,1648.167,1865.275,1649.647,1864.253,1650.25z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BBE0FD"
    },
    d: "M97.005,958.001v42.49l0.225-0.163c0.632,3.752,2.813,7.279,6.565,9.44l142.783,82.431 c2.121,1.224,4.485,1.835,6.851,1.815c2.324-0.02,4.648-0.611,6.728-1.815l142.946-82.758c4.526-2.61,6.749-7.197,6.749-11.764 v-39.677l-29.972,14.578L260.38,903.767c-4.2-2.406-9.358-2.406-13.559,0.02l-92.32,53.235l-23.957,13.803L97.005,958.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M97.005,958.001v42.49l0.225-0.163c0.632,3.752,2.813,7.279,6.565,9.44l142.783,82.431 c2.121,1.224,4.485,1.835,6.851,1.815v-51.155l-98.926-85.837l-23.957,13.803L97.005,958.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.387,863.786l142.68,82.146c9.059,5.216,9.075,18.283,0.028,23.521l-142.931,82.752 c-4.204,2.434-9.387,2.437-13.594,0.008l-142.78-82.434c-9.056-5.229-9.052-18.302,0.007-23.525l143.031-82.464 C251.024,861.371,256.19,861.37,260.387,863.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M260.387,862.508l142.68,82.146c9.059,5.216,9.075,18.283,0.028,23.521l-142.931,82.752 c-4.204,2.434-9.387,2.437-13.594,0.008l-142.78-82.434c-9.056-5.229-9.052-18.302,0.007-23.525l143.031-82.464 C251.024,860.094,256.19,860.092,260.387,862.508z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M140.331,979.234l14.706,8.901l12.686-7.258c2.391,0.771,4.949,1.388,7.632,1.832 v8.522h17.802v-8.225c3.427-0.444,6.671-1.169,9.657-2.133l13.37,7.65l14.706-8.901l-13.376-7.584 c2.546-2.887,3.984-6.159,3.984-9.628c0-3.573-1.527-6.938-4.218-9.887l12.837-7.344l-14.706-8.514l-12.753,7.231 c-2.659-0.849-5.522-1.508-8.532-1.949v-8.378h-17.802v8.391c-2.979,0.44-5.813,1.093-8.447,1.933l-12.065-6.841l-14.706,8.514 l12.146,6.95c-2.696,2.951-4.225,6.319-4.225,9.895c0,3.47,1.439,6.745,3.989,9.633L140.331,979.234z M173.615,962.409 c0-3.746,5.214-6.782,11.647-6.782s11.647,3.036,11.647,6.782c0,3.746-5.214,6.782-11.647,6.782S173.615,966.154,173.615,962.409 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A302"
    },
    d: "M140.331,939.806l12.683-7.192c-2.549-2.888-3.989-6.163-3.989-9.633 c0-1.788,0.207-11.426,0.207-11.426s2.671,3.007,4.019,1.531l-12.146-6.949l14.706-8.514l12.065,6.841 c5.161-1.647,11.085-2.584,17.386-2.584c6.305,0,12.232,0.938,17.396,2.587l12.753-7.231l14.706,8.514l-12.836,7.345 c1.335,1.463,4.322-2.314,4.322-2.314s-0.104,10.4-0.104,12.2c0,3.468-1.437,6.741-3.984,9.628l13.376,7.584l-14.706,8.901 l-13.37-7.65c-5.2,1.68-11.184,2.638-17.552,2.638c-6.363,0-12.341-0.956-17.538-2.633l-12.686,7.258L140.331,939.806z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.162,
    y: 939.806,
    style: {
      fill: "#FEC400"
    },
    width: 17.802,
    height: 11.61
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "155.037,936.71 155.037,948.707 140.331,939.806 140.331,927.809  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "141.105,894.14 141.105,906.137 150.006,911.168 155.037,900.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "216.184,937.097 216.184,949.094 230.89,940.193 230.89,928.196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "230.116,893.753 230.116,905.75 220.647,911.168 216.571,901.106  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M140.331,927.809l14.706,8.901l12.686-7.258c2.391,0.772,4.949,1.388,7.632,1.832v8.522h17.802 v-8.225c3.427-0.444,6.671-1.169,9.657-2.133l13.37,7.65l14.706-8.901l-13.376-7.584c2.546-2.887,3.984-6.16,3.984-9.628 c0-3.573-1.527-6.937-4.218-9.887l12.837-7.344l-14.706-8.514l-12.753,7.231c-2.659-0.849-5.522-1.508-8.532-1.949v-8.378 h-17.802v8.391c-2.979,0.44-5.813,1.093-8.447,1.933l-12.065-6.841l-14.706,8.514l12.146,6.949 c-2.696,2.951-4.225,6.319-4.225,9.895c0,3.471,1.439,6.746,3.989,9.634L140.331,927.809z M173.615,910.984 c0-3.746,5.214-6.782,11.647-6.782s11.647,3.036,11.647,6.782c0,3.746-5.214,6.782-11.647,6.782S173.615,914.73,173.615,910.984z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M235.033,971.398l21.078,12.758l18.182-10.403c3.427,1.106,7.093,1.99,10.939,2.625 v12.215h25.516v-11.79c4.912-0.636,9.562-1.675,13.841-3.058l19.163,10.964l21.078-12.758l-19.171-10.87 c3.649-4.137,5.71-8.828,5.71-13.799c0-5.121-2.189-9.943-6.046-14.171l18.399-10.527l-21.078-12.203l-18.279,10.364 c-3.811-1.217-7.914-2.161-12.23-2.794v-12.008h-25.516v12.026c-4.27,0.631-8.332,1.566-12.106,2.771l-17.292-9.805 l-21.078,12.203l17.409,9.961c-3.864,4.23-6.056,9.057-6.056,14.182c0,4.974,2.063,9.668,5.718,13.808L235.033,971.398z  M282.738,947.283c0-5.369,7.474-9.721,16.693-9.721c9.219,0,16.693,4.352,16.693,9.721s-7.474,9.721-16.693,9.721 C290.212,957.004,282.738,952.651,282.738,947.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8A302"
    },
    d: "M235.033,930.037l18.179-10.307c-3.654-4.139-5.717-8.833-5.717-13.808 c0-2.563,0.296-16.377,0.296-16.377s3.828,4.31,5.76,2.195l-17.409-9.961l21.078-12.203l17.292,9.805 c7.398-2.36,15.889-3.703,24.919-3.703c9.036,0,17.532,1.345,24.933,3.708l18.279-10.364l21.078,12.203l-18.398,10.527 c1.914,2.097,6.195-3.316,6.195-3.316s-0.15,14.906-0.15,17.487c0,4.971-2.06,9.662-5.71,13.799l19.172,10.87l-21.078,12.758 l-19.163-10.964c-7.453,2.408-16.029,3.781-25.158,3.781c-9.12,0-17.689-1.37-25.138-3.774l-18.183,10.403L235.033,930.037z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.955,
    y: 930.037,
    style: {
      fill: "#FEC400"
    },
    width: 25.516,
    height: 16.641
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "256.111,925.6 256.111,942.795 235.033,930.037 235.033,912.842  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "236.142,864.584 236.142,881.779 248.9,888.99 256.111,873.459  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "343.752,926.154 343.752,943.35 364.83,930.592 364.83,913.396  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC400"
    },
    points: "363.721,864.029 363.721,881.224 350.149,888.99 344.307,874.568  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M235.033,912.842l21.078,12.758l18.182-10.403c3.427,1.106,7.093,1.99,10.939,2.625v12.215h25.516 v-11.789c4.912-0.636,9.562-1.675,13.841-3.058l19.163,10.964l21.078-12.758l-19.171-10.87c3.649-4.137,5.71-8.828,5.71-13.799 c0-5.121-2.189-9.943-6.046-14.171l18.399-10.527l-21.078-12.203l-18.279,10.364c-3.811-1.217-7.914-2.161-12.23-2.794v-12.008 h-25.516v12.026c-4.27,0.631-8.332,1.566-12.106,2.771l-17.292-9.805l-21.078,12.203l17.409,9.961 c-3.864,4.23-6.056,9.057-6.056,14.182c0,4.974,2.063,9.668,5.718,13.808L235.033,912.842z M282.738,888.726 c0-5.369,7.474-9.721,16.693-9.721c9.219,0,16.693,4.352,16.693,9.721s-7.474,9.721-16.693,9.721 C290.212,898.447,282.738,894.095,282.738,888.726z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.22,
      fill: "#15325C"
    },
    d: "M906.706,871.345l-624.267,362.58l247.066,142.644 c178.132,102.844,397.688,102.465,575.464-0.995l335.579-195.296L906.706,871.345z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D6EDFF"
    },
    d: "M1440.547,1065.079l-335.578,195.297c-177.775,103.46-397.331,103.839-575.463,0.995 l-247.067-142.644l624.266-362.581L1440.547,1065.079z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "1440.547,1017.906 1440.547,1065.079 1400.018,1041.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EDFF"
    },
    points: "323.76,1094.726 282.439,1118.726 282.439,1071.553  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1068.356,1226.967 1069.161,1279.545 1440.547,1065.079 1440.547,1017.906  841.209,1260.194  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M906.706,708.973l-624.267,362.58l247.066,142.644c178.132,102.845,397.688,102.465,575.464-0.995 l335.579-195.296L906.706,708.973z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "535.898,1217.824 535.898,1264.997 486.786,1236.706 486.786,1189.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "549.953,1225.455 549.953,1272.615 568.361,1281.854 568.361,1234.682  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1004.922,
    y: 1083.3,
    transform: "matrix(0.8566 -0.516 0.516 0.8566 -407.6666 713.0787)",
    style: {
      fill: "#5B95D3"
    },
    width: 148.227,
    height: 13.31
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1059.481,
    y: 895.995,
    transform: "matrix(0.5145 -0.8575 0.8575 0.5145 -310.5881 1383.1221)",
    style: {
      fill: "#5B95D3"
    },
    width: 13.308,
    height: 139.689
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M478.003,633.943c-2.142-9.714-7.104-16.883-14.369-19.177 c-7.837-2.475-16.737,1.238-24.491,9.109c-3.633-12.919-10.809-22.347-20.93-25.544c-21.934-6.927-49.357,17.993-61.253,55.659 c-0.72,2.279-1.362,4.552-1.937,6.813c-11.726,3.564-23.646,17.579-29.619,36.491c-2.687,8.509-3.82,16.9-3.566,24.436 l-1.248,0.716c-9.281,5.323-15.005,15.205-15.005,25.904v0c0,22.95,24.811,37.322,44.719,25.904l148.357-85.087 c9.281-5.323,15.005-15.205,15.005-25.904v0C513.667,643.706,495.65,630.391,478.003,633.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1449.81,794.646l-1.597-0.915c0.325-9.638-1.124-20.369-4.561-31.25 c-7.638-24.185-22.882-42.109-37.878-46.667c-0.735-2.892-1.557-5.799-2.477-8.713c-15.213-48.17-50.284-80.039-78.334-71.18 c-12.944,4.088-22.121,16.145-26.767,32.667c-9.916-10.065-21.298-14.814-31.32-11.649c-9.291,2.934-15.638,12.103-18.376,24.525 c-22.568-4.542-45.609,12.485-45.609,37.496v0c0,13.683,7.32,26.321,19.19,33.128l189.73,108.815 c25.46,14.602,57.19-3.778,57.19-33.128v0C1469,814.091,1461.68,801.453,1449.81,794.646z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1279.236,1063.868 1278.564,1064.259 1171.678,1125.973 1171.007,1125.583  1064.134,1063.868 1096.695,1044.795 1170.176,1001.775 1246.21,1045.064 1278.576,1063.489  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1171.678,1050.831 1171.007,1088.317 1170.554,1113.572 1064.134,1052.432  1064.134,1026.602 1096.695,1007.529  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23477C"
    },
    points: "1278.576,1026.224 1278.564,1026.993 1278.112,1052.432 1170.554,1113.572  1171.007,1088.317 1171.678,1050.831 1246.21,1007.798  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1279.236,1026.602 1278.564,1026.993 1171.678,1088.708 1171.007,1088.317  1064.134,1026.602 1096.695,1007.529 1170.176,964.509 1246.21,1007.798 1278.576,1026.224  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD561"
    },
    points: "1098.155,1026.495 1170.296,984.26 1244.851,1026.708 1171.682,1068.955  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "1107.879,1026.467 1170.33,989.904 1235.025,1026.738 1171.682,1063.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "1157.01,1026.575 1171.197,1018.269 1185.894,1026.637 1171.504,1034.946  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1170.33,994.791 1230.763,1029.198 1235.025,1026.738 1170.33,989.904 1107.879,1026.467  1112.081,1028.894  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "726.954,530.289 938.491,651.168 1147.282,530.289 935.744,403.916  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    d: "M733.62,931.214l191.935,116.134c5.092,3.081,11.464,3.122,16.596,0.106 l197.797-116.246c5.306-3.118,7.973-8.509,7.992-13.909c0.019-5.4-2.609-10.81-7.892-13.966L944.001,786.214 c-5.146-3.074-11.569-3.056-16.698,0.048L733.618,903.493C723.201,909.798,723.202,924.911,733.62,931.214z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23477C"
    },
    points: "935.744,651.168 935.744,1024.793 1147.282,898.419 1147.282,527.542  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M960.469,981.22V665.355l162.087-94.724v313.757L960.469,981.22z M965.964,668.51v303.026 l151.098-90.265V580.203L965.964,668.51z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "726.954,527.542 726.954,898.419 935.744,1024.793 935.744,651.168  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#23477C"
    },
    d: "M749.278,883.254V583.672c0-4.156,1.996-7.615,4.922-9.771c3.704-2.729,8.9-3.368,13.426-0.688 l139.831,82.793c3.696,2.188,5.962,6.164,5.962,10.459v301.424c0,9.469-10.348,15.302-18.449,10.399l-139.831-84.634 C751.501,891.451,749.278,887.507,749.278,883.254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M774.024,885.412c-3.639-2.203-5.862-6.146-5.862-10.399V575.429c0-0.557,0.042-1.099,0.111-1.629 l-0.994-0.588c-4.526-2.68-9.721-2.04-13.426,0.688c-2.926,2.156-4.922,5.615-4.922,9.771v299.583 c0,4.253,2.223,8.197,5.862,10.399l139.83,84.634c7.629,4.616,17.241-0.288,18.34-8.782L774.024,885.412z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "913.766,680.304 776.404,598.97 776.404,645.673 913.766,727.007  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "913.766,737.996 776.404,656.662 776.404,703.365 913.766,784.699  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "913.766,795.688 776.404,714.354 776.404,761.057 913.766,842.391  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "913.766,853.38 776.404,772.046 776.404,818.75 913.766,900.083  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "913.766,911.072 776.404,829.738 776.404,876.442 913.766,957.775  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "799.983,620.948 799.983,651.618 890.187,705.029 890.187,674.359  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "799.983,709.31 890.187,762.721 890.187,732.051 799.983,678.64  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "799.983,767.002 890.187,820.413 890.187,789.743 799.983,736.332  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "799.983,824.694 890.187,878.105 890.187,847.435 799.983,794.024  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D6EFFB"
    },
    points: "799.983,882.386 890.187,935.797 890.187,905.127 799.983,851.716  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "886.997,1207.545 885.492,1206.662 722.023,1110.836 725.058,1105.66 887.021,1200.604  995.428,1138.062 998.426,1143.259  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "1114.202,1157.032 1113.531,1157.423 1006.645,1219.138 1005.973,1218.747  899.1,1157.032 931.661,1137.959 1005.142,1094.939 1081.176,1138.228 1113.542,1156.653  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1006.645,1146.657 1005.973,1184.143 1005.521,1209.398 899.1,1148.258 899.1,1122.428  931.661,1103.356  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23477C"
    },
    points: "1113.542,1122.05 1113.531,1122.82 1113.078,1148.258 1005.521,1209.398  1005.973,1184.143 1006.645,1146.657 1081.176,1103.624  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "1114.202,1122.428 1113.531,1122.82 1006.645,1184.534 1005.973,1184.143 899.1,1122.428  931.661,1103.356 1005.142,1060.335 1081.176,1103.624 1113.542,1122.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD561"
    },
    points: "933.121,1122.321 1005.262,1080.086 1079.817,1122.534 1006.648,1164.781  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "942.845,1122.293 1005.296,1085.73 1069.991,1122.564 1006.648,1159.137  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "991.976,1122.402 1006.163,1114.095 1020.86,1122.463 1006.47,1130.772  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "1005.296,1090.617 1065.729,1125.025 1069.991,1122.564 1005.296,1085.73  942.845,1122.293 947.047,1124.72  "
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    cx: 556.51,
    cy: 1004.437,
    rx: 73.136,
    ry: 42.589
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CAAB"
    },
    d: "M563.035,828.384l-12.199,79.953l-23.185,85.648c0,0-3.435,6.108-13.934-3.815l10.235-82.016 l-3.722-110.76L563.035,828.384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M527.86,992.897c0,0,15.939,10.973,17.275,15.744c1.337,4.771,0.497,9.123-3.854,8.284 c-4.352-0.839-26.989-6.333-34.395-8.89c-7.406-2.557,7.34-20.765,7.34-20.765S515.722,997.326,527.86,992.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4CAAB"
    },
    d: "M590.713,812.965l3.161,80.816l-6.548,88.489c0,0-2.216,6.648-14.404-1.108l-5.54-83.1 L542.815,790.64L590.713,812.965z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M587.326,981.162c0,0,17.728,7.756,19.944,12.188c2.216,4.432,2.216,8.864-2.216,8.864 c-4.432,0-27.7-1.108-35.456-2.216c-7.756-1.108,3.275-21.779,3.275-21.779S576.246,987.81,587.326,981.162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1249A"
    },
    d: "M596.578,893.83c-1.211,26.643-4.844,77.506-4.844,77.506s-18.166,4.844-23.01,0l-0.63-39.31 l-0.581-35.774l-21.799-80.049l16.627-3.548l28.181-6.019C590.523,806.636,597.789,867.187,596.578,893.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BC1D87"
    },
    d: "M571.147,893.83l-3.052,38.196l-0.581-35.774l-21.799-80.049l16.627-3.548 C561.858,859.788,571.147,893.83,571.147,893.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1249A"
    },
    d: "M519.072,815.113c1.211,7.266,4.76,89.451,4.76,89.451l-10.815,69.194 c7.266,9.688,21.799,4.844,21.799,4.844l19.376-71.451l12.11-60.552v-29.065C566.303,817.535,517.861,807.847,519.072,815.113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M670.461,763.967c0,0,4.448-4.171,8.49-3.213c4.042,0.958,0.795,5.34,0.795,5.34 c11.378,5.715,8.781,9.221,8.781,9.221c-1.916,8.083-5.958,7.125-5.958,7.125c-5.016,0.357-16.848-8.41-16.848-8.41 L670.461,763.967z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M672.71,761.297l-53.632-15.809c0,0-23.951-33.81-37.999-44.698l-10.669,17.373l-3.645,5.924 c0,0,34.889,39.877,42.401,41.475c7.106,1.487,53.509,10.259,58.709,11.21c0.065-0.006,0.114,0.006,0.146,0.036 c0.065,0.027,0.13,0.021,0.179,0.033c0.098,0.024,0.147,0.037,0.147,0.037L672.71,761.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M565.951,695.387l-29.227-31.372c-11.604,27.369,10.084,48.195-18.419,69.815 C489.801,755.449,588.712,784.811,565.951,695.387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC400"
    },
    d: "M517.522,738.687l1.274,6.185c4.998,24.265,4.563,49.336-1.274,73.413l0,0 c0,0,51.195,13.517,75.345-6.648l-0.188-1.125c-3.558-21.349-4.831-43.017-3.795-64.636l1.63-34.042c0,0-0.814-5.427-5.418-9.977 c-2.327-2.3-5.284-3.675-8.377-4.082c-3.093-0.408-6.322,0.152-9.193,1.721l-39.593,21.638c-2.598,1.42-4.799,3.368-6.498,5.669 C518.936,730.187,517.522,734.334,517.522,738.687z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M567.792,716.026c0,0-14.992,4.566-21.508-2.604v-37.99l6.6,6.661l12.946,13.079l1.465,15.562 L567.792,716.026z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M567.295,710.734c-7.06-5.038-14.266-13.818-14.411-28.641l12.946,13.079L567.295,710.734z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC400"
    },
    d: "M590.65,711.918l-4.432,44.32C607.27,746.266,590.65,711.918,590.65,711.918z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M589.26,826.938c0,0,5.9-1.542,8.994,1.23c3.094,2.771-1.851,5.072-1.851,5.072 c7.27,10.453,3.313,12.294,3.313,12.294c-5.543,6.188-8.637,3.417-8.637,3.417c-4.578-2.081-10.789-15.433-10.789-15.433 L589.26,826.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD561"
    },
    d: "M592.511,825.666l-39.579-39.495c0,0-4.025-33.758-10.093-52.212 c-1.064-3.235-3.168-6.018-5.996-7.917l0,0c-4.745-3.186-10.37-2.686-14.424,0.131c-3.354,2.33-5.632,6.246-5.444,10.97 l0.149,3.766c0.039,0.994,0.169,1.973,0.392,2.942c1.939,8.439,11.872,50.735,17.125,55.225 c5.534,4.699,42.12,34.559,46.236,37.877c0.06,0.026,0.097,0.06,0.111,0.101c0.045,0.055,0.104,0.081,0.142,0.114 c0.074,0.068,0.111,0.103,0.111,0.103L592.511,825.666z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M576.049,656.714c0,0,17.705,47.176-2.356,47.961c-20.061,0.786-31.31-20.453-31.31-20.453 l8.53-20.595L576.049,656.714z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M544.01,656.931c-22.724,15.836,1.438,32.038,1.438,32.038l4.585-1.529 c4.915-3.162,4.784-9.198,4.784-9.198c15.75,6.845,19.332-7.342,26.987-1.481C586.721,656.613,566.735,641.096,544.01,656.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BEAE"
    },
    d: "M551.127,683.408c2.856,2.744,3.53,6.676,1.506,8.782c-2.024,2.107-5.98,1.59-8.836-1.153 c-2.856-2.744-3.53-6.676-1.506-8.783C544.315,680.148,548.271,680.664,551.127,683.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#052754"
    },
    d: "M582.572,664.359c-9.793-11.524-28.309,4.219-28.309,4.219l-3.703,12.11 c3.703,6.055,2.16,6.055,3.549,8.477c1.388,2.422,2.623-7.266,2.623-7.266C577.716,686.743,592.365,675.883,582.572,664.359z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.33,
      fill: "#15325C"
    },
    points: "859.246,1097.577 857.988,1098.308 657.938,1213.814 656.681,1213.083  456.656,1097.577 517.599,1061.879 655.127,981.361 797.433,1062.382 858.011,1096.867  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "657.938,1078.158 656.681,1148.317 655.835,1195.585 456.656,1081.154 456.656,1032.811  517.599,997.114  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#23477C"
    },
    points: "858.011,1032.102 857.988,1033.543 857.142,1081.154 655.835,1195.585 656.681,1148.317  657.938,1078.158 797.433,997.617  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C6A9E"
    },
    points: "859.246,1032.811 857.988,1033.543 657.938,1149.049 656.681,1148.317 456.656,1032.811  517.599,997.114 655.127,916.596 797.433,997.617 858.011,1032.102  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD561"
    },
    points: "520.331,1032.611 655.35,953.562 794.889,1033.008 657.945,1112.079  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#5B95D3"
    },
    points: "538.529,1032.557 655.415,964.125 776.499,1033.064 657.945,1101.516  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BBE0FD"
    },
    points: "630.484,1032.761 657.037,1017.215 684.544,1032.876 657.612,1048.426  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#183561"
    },
    points: "655.415,973.272 768.522,1037.67 776.499,1033.064 655.415,964.125 538.529,1032.557  546.394,1037.099  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.54e9b8039525d1816a7cbdf0857451f0.svg";
export { ForwardRef as ReactComponent };